<section class="overflow-hidden">
  <div class="relative">
    <div class="absolute top-0 w-full left-0 h-[45vh] md:h-[65vh] 3xl:h-screen" [@fadeInDown]>
      <!-- <svg id="xxx" xmlns="http://www.w3.org/2000/svg" class="mx-auto laptop:w-[60%] 3xl:w-[80%]" viewBox="0 0 1280 576.021">
        <g id="Group_2184" data-name="Group 2184" opacity="0.63">
          <path id="h1-6" data-name="Path 3712" d="M1376.444,343.058H103.556L100,0H1380Z" transform="translate(-100)"
            fill="#f8f4eb" />
          <path id="Path_3713" data-name="Path 3713"
            d="M391.678,70.6a14.5,14.5,0,1,1,3.893-28.453,26.509,26.509,0,0,1,48.782-12.338,20.039,20.039,0,0,1,28.279,8.341,14.44,14.44,0,0,1,18.184,12.737,10.944,10.944,0,0,1,16.574,8.069,6.293,6.293,0,1,1,1.995,12.262Z"
            transform="translate(-48.67 3.254)" fill="#fff" />
          <path id="h1-2" data-name="Path 3714"
            d="M1376.491,184.358a3.673,3.673,0,0,0,.09-.75c0-2.6-2.688-17.719-6-17.719-2.259,0-4.226,7.02-5.25,12.315-.273-.145-.542-.294-.815-.44a3.648,3.648,0,0,0,.064-.535c0-2.6-2.688-17.72-6-17.72-1.623,0-3.094,3.627-4.175,7.631-.571-4.672-2.983-16.155-5.873-16.155-1.708,0-3.247,4.01-4.34,8.252-1.093-4.243-2.632-8.252-4.339-8.252-1.619,0-3.087,3.608-4.167,7.6-.557-4.629-2.978-16.222-5.882-16.222-1.684,0-3.207,3.906-4.3,8.089-1.349-7-3.956-16.352-6.952-16.352-2.645,0-4.987,7.291-6.427,13.82-1.44-6.529-3.782-13.82-6.428-13.82-1.355,0-2.631,1.915-3.746,4.659-1.248-7.083-4.008-17.791-7.215-17.791-3.055,0-5.705,9.716-7.028,16.76-1.454-6.165-3.663-12.538-6.137-12.538-2.375,0-4.5,5.875-5.958,11.8-1.1-4.59-2.747-9.25-4.588-9.25-1.193,0-2.3,1.963-3.239,4.593-1.243-7.083-4.01-17.85-7.226-17.85-2.425,0-4.594,6.121-6.048,12.169-1.415-5.106-3.308-9.621-5.39-9.621-2.8,0-5.261,8.168-6.672,14.956-1.161-7.032-4.024-18.7-7.372-18.7-2.507,0-4.74,6.542-6.193,12.782-1.1-6.949-4.025-19.279-7.467-19.279-3.278,0-6.092,11.2-7.3,18.263-1.843-11.243-6.446-30.131-11.838-30.131-4.454,0-8.371,12.9-10.637,23.724-1.393-4.82-3.208-8.943-5.2-8.943-1.139,0-2.22,1.356-3.2,3.415-1.42-5.183-3.334-9.813-5.442-9.813-2.031,0-3.883,4.3-5.286,9.247-2.3-10.509-6.073-22.332-10.338-22.332-5.236,0-9.732,17.824-11.674,29.15-1.453-6.177-3.666-12.577-6.145-12.577-2.014,0-3.851,4.224-5.249,9.119-1.441-6.509-3.775-13.743-6.411-13.743-3.4,0-6.293,12.011-7.422,19-1.013-5.317-3-12.5-5.287-12.5-1.8,0-3.406,4.436-4.506,8.916-.933-5.361-3.039-13.62-5.49-13.62-1.555,0-2.971,3.324-4.037,7.123-2.312-8.972-5.567-17.442-9.176-17.442-4.39,0-8.258,12.526-10.54,23.25-1.427-5.3-3.374-10.1-5.521-10.1-1.9,0-3.651,3.775-5.017,8.324-1.1-4.507-2.719-9-4.526-9-1.491,0-2.855,3.063-3.905,6.667-1.087-4.977-2.874-10.6-4.9-10.6a1.838,1.838,0,0,0-1.312.777c-1.1-4.727-2.791-9.684-4.69-9.684-3,0-5.491,12.4-5.933,16.674l-.18-.073c-.732-6.1-3.932-21.439-7.77-21.439-2.646,0-4.99,7.295-6.43,13.826-.676-4.951-3.017-15.635-5.8-15.635-2.407,0-4.482,7.967-5.439,13.329-.659-4.909-3.014-15.725-5.818-15.725-1.2,0-2.321,1.991-3.259,4.648-1.348-7.006-3.956-16.364-6.953-16.364-2.9,0-5.439,8.766-6.82,15.682-1.348-4.365-3.046-7.918-4.891-7.918-1.947,0-3.729,3.949-5.109,8.635h0c-1.324-7.044-3.973-16.749-7.026-16.749-1.8,0-3.455,3.366-4.785,7.571-1.024-6.828-4.015-19.819-7.548-19.819-2.672,0-5.032,7.431-6.469,14.008-1.265-3.684-2.788-6.483-4.428-6.483-1.859,0-3.569,3.607-4.921,8.017-1.435-6.6-3.806-14.1-6.49-14.1-2.063,0-3.943,4.437-5.353,9.489-2.327-9.44-5.723-18.753-9.508-18.753-3.655,0-6.948,8.687-9.265,17.785-.755-6.171-3.941-21.335-7.757-21.335-3.419,0-6.334,12.179-7.445,19.15-1.338-7.022-3.965-16.525-6.986-16.525-2.043,0-3.906,4.351-5.312,9.339-2.313-10.36-6.025-21.758-10.213-21.758-4.625,0-8.671,13.9-10.891,24.949l-.089-.012c-.992-6.763-4.011-20.044-7.582-20.044-2.4,0-4.552,6.005-6.007,12-1.4-6.816-3.88-15.1-6.7-15.1-2.854,0-5.356,8.486-6.752,15.346-1.357-4.449-3.077-8.1-4.949-8.1-2.29,0-4.352,5.464-5.8,11.167-1.09-6.939-4.024-19.328-7.474-19.328-2.7,0-5.09,7.615-6.522,14.248-1.431-5.348-3.391-10.225-5.554-10.225s-4.134,4.9-5.564,10.26c-1.454-6.157-3.661-12.512-6.131-12.512-1.417,0-2.746,2.1-3.9,5.041-1.439-5.5-3.442-10.611-5.657-10.611-2.856,0-5.359,8.494-6.754,15.356-2.212-11.083-6.278-25.148-10.93-25.148-4.12,0-7.78,11.034-10.1,21.256-1.812-11.208-6.447-30.4-11.881-30.4-5.189,0-9.649,17.5-11.618,28.837-2.293-8.6-5.442-16.455-8.92-16.455-4.03,0-7.617,10.554-9.944,20.581-2.31-10.42-6.046-21.99-10.265-21.99-4.433,0-8.333,12.773-10.605,23.565-1.453-6.217-3.679-12.709-6.175-12.709-3.243,0-6.028,10.938-7.256,18.016-1.4-6.859-3.9-15.335-6.751-15.335-3.083,0-5.752,9.892-7.064,16.949-1.1-6.948-4.024-19.285-7.467-19.285-3.565,0-6.58,13.24-7.577,20.013-1.454-6.19-3.671-12.619-6.156-12.619-2.225,0-4.236,5.159-5.675,10.683-2.328-10-5.9-20.476-9.92-20.476-4.778,0-8.936,14.833-11.1,26.034-1.411-6.778-3.867-14.91-6.662-14.91-3.808,0-6.987,15.093-7.751,21.292-1.449-6.356-3.725-13.182-6.285-13.182-2.671,0-5.032,7.432-6.469,14.009-2.251-7.973-5.23-14.918-8.5-14.918-3.429,0-6.537,7.643-8.821,16.1-2.308-8.868-5.532-17.163-9.1-17.163-4.23,0-7.975,11.633-10.283,22.076-1.448-5.722-3.516-11.22-5.815-11.22-3.657,0-6.734,13.927-7.649,20.519-1.449-6.342-3.719-13.131-6.273-13.131-2.223,0-4.233,5.153-5.672,10.674-2.266-8.172-5.3-15.4-8.632-15.4-3.589,0-6.829,8.379-9.138,17.3-4.07-14.592-9.5-27.429-15.458-27.429-8.338,0-15.631,25.109-19.624,45.016-2.542-4.762-5.3-7.778-8.191-7.778-4.2,0-8.142,6.388-11.526,15.27-2.325-9.34-5.691-18.466-9.438-18.466-3.84,0-7.278,9.582-9.607,19.16l-.467-.058c-2.278-8.35-5.358-15.836-8.751-15.836-2.574,0-4.968,4.315-6.969,10.043-1.441-6.526-3.781-13.805-6.425-13.805-1.736,0-3.341,3.141-4.646,7.143-2.118-6.624-4.744-11.889-7.59-11.889-3.187,0-6.1,6.609-8.327,14.331-2.3-10.495-6.069-22.28-10.328-22.28-3.871,0-7.335,9.741-9.664,19.4-1.933-5.262-4.206-9.12-6.641-9.12-3.655,0-6.948,8.686-9.265,17.785-.092,0-.186,0-.279,0-2.248-7.955-5.222-14.873-8.484-14.873-2.656,0-5.12,4.588-7.159,10.586-2.329-9.574-5.766-19.149-9.6-19.149-3.41,0-6.5,7.561-8.785,15.962-2.281-8.4-5.375-15.962-8.785-15.962-4.875,0-9.1,15.442-11.233,26.713l-.041,0c-2.242-7.87-5.192-14.674-8.427-14.674-3.063,0-5.87,6.1-8.064,13.422-1.3-3.986-2.9-7.111-4.635-7.111-2.347,0-4.455,5.737-5.907,11.591-2.318-9.141-5.623-17.9-9.294-17.9-3.757,0-7.131,9.177-9.457,18.545-2.284-8.439-5.388-16.057-8.811-16.057-3.552,0-6.763,8.206-9.067,17.02-1.311-4.043-2.926-7.228-4.674-7.228-2.319,0-4.405,5.6-5.856,11.385-1.385-4.759-3.186-8.8-5.156-8.8-2.732,0-5.14,7.77-6.566,14.45-2.172-7.122-4.926-12.971-7.924-12.971-2.9,0-5.564,5.458-7.7,12.249-2.18-11.174-6.313-25.8-11.057-25.8-5.823,0-10.726,22.023-12.225,32.661-1.311-4.044-2.926-7.232-4.676-7.232-2.414,0-4.576,6.075-6.03,12.1-1.243-3.535-2.727-6.19-4.322-6.19-3.025,0-5.653,9.528-6.99,16.552-3.615-10.4-7.951-18.261-12.614-18.261-4.119,0-7.981,6.127-11.319,14.726-1.6-3.456-3.381-5.754-5.256-5.754-3.166,0-6.059,6.52-8.282,14.175a6.375,6.375,0,0,0-4.417-2.3c-2.866,0-5.608,2.975-8.136,7.678-1.894-5.018-4.1-8.648-6.464-8.648-5.988,0-11,23.3-12.345,33.547-.117.071-.237.14-.353.211v90.057h1274.38V184.5C1376.665,184.454,1376.578,184.407,1376.491,184.358ZM1353.4,171.424c-.04.206-.081.41-.119.61-.108-.052-.213-.105-.32-.159A4.914,4.914,0,0,0,1353.4,171.424Zm-18.816-8.075-.306-.133a5.03,5.03,0,0,0,.418-.439C1334.66,162.972,1334.623,163.161,1334.587,163.35Z"
            transform="translate(-99.561 3.127)" fill="#dfd2bf" />
          <path id="h1-4" data-name="Path 3715"
            d="M1378.8,151.7a24.98,24.98,0,0,0-46.268-13.137,49.072,49.072,0,0,0-42.676,1.249,24.848,24.848,0,0,0-25.222-.5,49.1,49.1,0,0,0-60.652,9.811,24.88,24.88,0,0,0-31.688,5.236,49.453,49.453,0,0,0-7.956-.651,48.876,48.876,0,0,0-24.551,6.585,49.156,49.156,0,0,0-41.179-7.784,49.117,49.117,0,0,0-72.068-16.108q-3.211-.306-6.447-.511a49.069,49.069,0,0,0-66.561,1.311,49.109,49.109,0,0,0-68.5,16.376,24.983,24.983,0,0,0-22.891,16.5A48.966,48.966,0,0,0,848,177.1a24.862,24.862,0,0,0-26.79-2.982,49.165,49.165,0,0,0-38.9-2.112,49.138,49.138,0,0,0-88.026-4.068,49.128,49.128,0,0,0-72.5,20.447,49.113,49.113,0,0,0-52.07,5.851,24.77,24.77,0,0,0-21.172,2.469,49.119,49.119,0,0,0-34.885,6.24,49.067,49.067,0,0,0-62.336-7.475,24.846,24.846,0,0,0-24.636-2.425A49.04,49.04,0,0,0,388.812,175.2h-.031A24.91,24.91,0,0,0,355.045,164,49.089,49.089,0,0,0,306.1,152.936a49.15,49.15,0,0,0-43.343-25.979c-1.082,0-2.152.047-3.217.116a24.949,24.949,0,0,0-35.17-7.4,48.868,48.868,0,0,0-24.309-6.446,49.924,49.924,0,0,0-4.99.251,24.973,24.973,0,0,0-46.961,6.188,49.213,49.213,0,0,0-41.825,32.648q-2.72,1.211-5.408,2.482v156.14H1378.8V158.551c-.3-.094-.6-.181-.9-.274A25.009,25.009,0,0,0,1378.8,151.7Z"
            transform="translate(-99.838 18.418)" fill="#f8f4eb" />
          <path id="h1-5" data-name="Path 3716"
            d="M1273.53,100.306c-3.84-.363-7.731-.557-11.666-.557A122.384,122.384,0,0,0,1140.69,205.039a61.206,61.206,0,0,0-53.376,11.614,61.243,61.243,0,0,0-106.785,5.6,61.211,61.211,0,0,0-64.753,16.108,61.272,61.272,0,0,0-79.566-24.719,87.995,87.995,0,0,0-157.791-28.127,87.928,87.928,0,0,0-116.2,11.5,93.628,93.628,0,0,0-165.685,3.259,61.238,61.238,0,0,0-73.143,23.759,87.923,87.923,0,0,0-100.2-58.476c.126-1.875.212-3.762.212-5.67A83.87,83.87,0,0,0,141.8,76.068,59.466,59.466,0,0,0,100,.009V348.032H1380V0A106.664,106.664,0,0,0,1273.53,100.306Z"
            transform="translate(-100)" fill="#fff" />
          <g id="h2-3" data-name="Group 1971" transform="translate(599.957 126.459)">
            <g id="Group_1970" data-name="Group 1970" transform="translate(0)">
              <g id="Group_1910" data-name="Group 1910">
                <circle id="Ellipse_1459" data-name="Ellipse 1459" cx="88.196" cy="88.196" r="88.196" fill="#b8d6d6" />
              </g>
              <g id="Group_1911" data-name="Group 1911" transform="translate(90.218 6.745)">
                <path id="Path_3717" data-name="Path 3717"
                  d="M690.734,120.258c0,4.345-4.2,7.867-4.2,7.867s-4.2-3.522-4.2-7.867,4.2-7.867,4.2-7.867S690.734,115.913,690.734,120.258Z"
                  transform="translate(-682.335 -112.391)" fill="#68999d" />
              </g>
              <g id="Group_1912" data-name="Group 1912" transform="translate(59.795 34.546)">
                <path id="Path_3718" data-name="Path 3718"
                  d="M665.065,143.715c0,4.345-4.2,7.867-4.2,7.867s-4.2-3.522-4.2-7.867,4.2-7.867,4.2-7.867S665.065,139.37,665.065,143.715Z"
                  transform="translate(-656.666 -135.848)" fill="#68999d" />
              </g>
              <g id="Group_1913" data-name="Group 1913" transform="translate(11.647 54.715)">
                <path id="Path_3719" data-name="Path 3719"
                  d="M624.929,153.479c3.988,1.723,5.557,6.975,5.557,6.975s-4.9,2.459-8.888.736-5.557-6.975-5.557-6.975S620.939,151.755,624.929,153.479Z"
                  transform="translate(-616.041 -152.866)" fill="#68999d" />
              </g>
              <g id="Group_1914" data-name="Group 1914" transform="translate(72.456 13.812)">
                <path id="Path_3720" data-name="Path 3720"
                  d="M675.674,122.992c2.209,3.742.385,8.91.385,8.91s-5.408-.9-7.617-4.638-.386-8.91-.386-8.91S673.463,119.251,675.674,122.992Z"
                  transform="translate(-667.348 -118.354)" fill="#68999d" />
              </g>
              <g id="Group_1915" data-name="Group 1915" transform="translate(75.346 55.633)">
                <path id="Path_3721" data-name="Path 3721"
                  d="M678.113,158.278c2.209,3.742.385,8.91.385,8.91s-5.408-.9-7.617-4.638-.386-8.91-.386-8.91S675.9,154.537,678.113,158.278Z"
                  transform="translate(-669.787 -153.64)" fill="#68999d" />
              </g>
              <g id="Group_1916" data-name="Group 1916" transform="translate(10.668 73.805)">
                <path id="Path_3722" data-name="Path 3722"
                  d="M624.065,170.47c3.549,2.507,4,7.969,4,7.969s-5.3,1.4-8.849-1.108-4-7.968-4-7.968S620.515,167.963,624.065,170.47Z"
                  transform="translate(-615.215 -168.973)" fill="#68999d" />
              </g>
              <g id="Group_1917" data-name="Group 1917" transform="translate(25.518 37.769)">
                <path id="Path_3723" data-name="Path 3723"
                  d="M636.069,143.206c2.21,3.74.386,8.909.386,8.909s-5.408-.9-7.617-4.638-.386-8.909-.386-8.909S633.86,139.464,636.069,143.206Z"
                  transform="translate(-627.744 -138.568)" fill="#68999d" />
              </g>
              <g id="Group_1918" data-name="Group 1918" transform="translate(48.15 69.12)">
                <path id="Path_3724" data-name="Path 3724"
                  d="M655.165,169.658c2.21,3.74.386,8.909.386,8.909s-5.408-.9-7.618-4.638-.385-8.909-.385-8.909S652.956,165.916,655.165,169.658Z"
                  transform="translate(-646.84 -165.02)" fill="#68999d" />
              </g>
              <g id="Group_1919" data-name="Group 1919" transform="translate(80.056 33.954)">
                <path id="Path_3725" data-name="Path 3725"
                  d="M682.086,139.987c2.21,3.74.385,8.909.385,8.909s-5.407-.9-7.617-4.636-.385-8.91-.385-8.91S679.875,136.246,682.086,139.987Z"
                  transform="translate(-673.76 -135.349)" fill="#68999d" />
              </g>
              <g id="Group_1920" data-name="Group 1920" transform="translate(38.115 26.366)">
                <path id="Path_3726" data-name="Path 3726"
                  d="M647.221,130.442c3.55,2.507,4,7.968,4,7.968s-5.3,1.4-8.849-1.106-4-7.968-4-7.968S643.672,127.936,647.221,130.442Z"
                  transform="translate(-638.373 -128.946)" fill="#68999d" />
              </g>
              <g id="Group_1921" data-name="Group 1921" transform="translate(57.568 58.725)">
                <path id="Path_3727" data-name="Path 3727"
                  d="M663.635,157.745c3.55,2.505,4,7.968,4,7.968s-5.3,1.4-8.849-1.106-4-7.968-4-7.968S660.086,155.239,663.635,157.745Z"
                  transform="translate(-654.787 -156.249)" fill="#68999d" />
              </g>
              <g id="Group_1922" data-name="Group 1922" transform="translate(55.479 11.743)">
                <path id="Path_3728" data-name="Path 3728"
                  d="M661.374,122.994c1.21,4.173-1.843,8.725-1.843,8.725s-5.014-2.213-6.223-6.386,1.843-8.725,1.843-8.725S660.165,118.821,661.374,122.994Z"
                  transform="translate(-653.024 -116.608)" fill="#68999d" />
              </g>
              <g id="Group_1923" data-name="Group 1923" transform="translate(30.618 64.86)">
                <path id="Path_3729" data-name="Path 3729"
                  d="M640.4,167.813c1.21,4.173-1.843,8.725-1.843,8.725s-5.014-2.213-6.225-6.386,1.843-8.727,1.843-8.727S639.189,163.64,640.4,167.813Z"
                  transform="translate(-632.048 -161.426)" fill="#68999d" />
              </g>
              <g id="Group_1924" data-name="Group 1924" transform="translate(42.334 45.696)">
                <path id="Path_3730" data-name="Path 3730"
                  d="M650.284,151.642c1.21,4.173-1.843,8.725-1.843,8.725s-5.015-2.213-6.225-6.386,1.843-8.725,1.843-8.725S649.074,147.469,650.284,151.642Z"
                  transform="translate(-641.933 -145.256)" fill="#68999d" />
              </g>
              <g id="Group_1925" data-name="Group 1925" transform="translate(79.797 90.912)">
                <path id="Path_3731" data-name="Path 3731"
                  d="M673.542,191.274c0-4.345,4.2-7.867,4.2-7.867s4.2,3.522,4.2,7.867-4.2,7.867-4.2,7.867S673.542,195.619,673.542,191.274Z"
                  transform="translate(-673.542 -183.407)" fill="#68999d" />
              </g>
              <g id="Group_1926" data-name="Group 1926" transform="translate(106.787 126.457)">
                <path id="Path_3732" data-name="Path 3732"
                  d="M696.315,221.265c0-4.345,4.2-7.867,4.2-7.867s4.2,3.522,4.2,7.867-4.2,7.867-4.2,7.867S696.315,225.61,696.315,221.265Z"
                  transform="translate(-696.315 -213.398)" fill="#68999d" />
              </g>
              <g id="Group_1927" data-name="Group 1927" transform="translate(148.89 113.086)">
                <path id="Path_3733" data-name="Path 3733"
                  d="M737.4,210.44c-3.989-1.722-5.557-6.975-5.557-6.975s4.9-2.459,8.888-.736,5.557,6.975,5.557,6.975S741.385,212.163,737.4,210.44Z"
                  transform="translate(-731.84 -202.116)" fill="#68999d" />
              </g>
              <g id="Group_1928" data-name="Group 1928" transform="translate(93.908 148.668)">
                <path id="Path_3734" data-name="Path 3734"
                  d="M686.542,241.048c-2.21-3.74-.386-8.909-.386-8.909s5.408.9,7.618,4.636.385,8.91.385,8.91S688.751,244.79,686.542,241.048Z"
                  transform="translate(-685.448 -232.139)" fill="#68999d" />
              </g>
              <g id="Group_1929" data-name="Group 1929" transform="translate(90.217 107.557)">
                <path id="Path_3735" data-name="Path 3735"
                  d="M683.428,206.361c-2.21-3.74-.385-8.91-.385-8.91s5.407.9,7.617,4.638.385,8.91.385,8.91S685.638,210.1,683.428,206.361Z"
                  transform="translate(-682.335 -197.451)" fill="#68999d" />
              </g>
              <g id="Group_1930" data-name="Group 1930" transform="translate(153.191 96.765)">
                <path id="Path_3736" data-name="Path 3736"
                  d="M739.474,196.7c-3.55-2.507-4-7.968-4-7.968s5.3-1.4,8.85,1.107,4,7.968,4,7.968S743.022,199.21,739.474,196.7Z"
                  transform="translate(-735.469 -188.345)" fill="#68999d" />
              </g>
              <g id="Group_1931" data-name="Group 1931" transform="translate(140.047 125.421)">
                <path id="Path_3737" data-name="Path 3737"
                  d="M725.471,221.434c-2.209-3.742-.385-8.91-.385-8.91s5.407.9,7.617,4.638.385,8.909.385,8.909S727.681,225.175,725.471,221.434Z"
                  transform="translate(-724.378 -212.524)" fill="#68999d" />
              </g>
              <g id="Group_1932" data-name="Group 1932" transform="translate(117.414 94.07)">
                <path id="Path_3738" data-name="Path 3738"
                  d="M706.375,194.982c-2.209-3.742-.385-8.91-.385-8.91s5.407.9,7.617,4.638.386,8.909.386,8.909S708.585,198.723,706.375,194.982Z"
                  transform="translate(-705.282 -186.072)" fill="#68999d" />
              </g>
              <g id="Group_1933" data-name="Group 1933" transform="translate(85.508 129.236)">
                <path id="Path_3739" data-name="Path 3739"
                  d="M679.455,224.652c-2.21-3.74-.386-8.909-.386-8.909s5.408.9,7.618,4.638.385,8.909.385,8.909S681.664,228.394,679.455,224.652Z"
                  transform="translate(-678.361 -215.743)" fill="#68999d" />
              </g>
              <g id="Group_1934" data-name="Group 1934" transform="translate(124.013 140.518)">
                <path id="Path_3740" data-name="Path 3740"
                  d="M714.855,233.62c-3.55-2.505-4-7.968-4-7.968s5.3-1.4,8.85,1.106,4,7.968,4,7.968S718.4,236.125,714.855,233.62Z"
                  transform="translate(-710.85 -225.262)" fill="#68999d" />
              </g>
              <g id="Group_1935" data-name="Group 1935" transform="translate(96.378 90.002)">
                <path id="Path_3741" data-name="Path 3741"
                  d="M691.538,191c-3.55-2.505-4-7.968-4-7.968s5.3-1.4,8.849,1.106,4,7.969,4,7.969S695.087,193.5,691.538,191Z"
                  transform="translate(-687.533 -182.639)" fill="#68999d" />
              </g>
              <g id="Group_1936" data-name="Group 1936" transform="translate(104.56 108.159)">
                <path id="Path_3742" data-name="Path 3742"
                  d="M698.441,206.317c-3.55-2.505-4-7.968-4-7.968s5.3-1.4,8.85,1.106,4,7.969,4,7.969S701.99,208.822,698.441,206.317Z"
                  transform="translate(-694.436 -197.959)" fill="#68999d" />
              </g>
              <g id="Group_1937" data-name="Group 1937" transform="translate(110.869 149.883)">
                <path id="Path_3743" data-name="Path 3743"
                  d="M700.043,241.889c-1.21-4.173,1.843-8.725,1.843-8.725s5.014,2.213,6.225,6.386-1.843,8.727-1.843,8.727S701.253,246.062,700.043,241.889Z"
                  transform="translate(-699.76 -233.164)" fill="#68999d" />
              </g>
              <g id="Group_1938" data-name="Group 1938" transform="translate(135.729 96.764)">
                <path id="Path_3744" data-name="Path 3744"
                  d="M721.018,197.07c-1.21-4.173,1.843-8.725,1.843-8.725s5.015,2.214,6.225,6.387-1.843,8.725-1.843,8.725S722.228,201.243,721.018,197.07Z"
                  transform="translate(-720.735 -188.345)" fill="#68999d" />
              </g>
              <g id="Group_1939" data-name="Group 1939" transform="translate(124.014 115.93)">
                <path id="Path_3745" data-name="Path 3745"
                  d="M711.134,213.241c-1.21-4.173,1.842-8.725,1.842-8.725s5.015,2.213,6.225,6.386-1.843,8.727-1.843,8.727S712.343,217.414,711.134,213.241Z"
                  transform="translate(-710.851 -204.516)" fill="#68999d" />
              </g>
              <g id="Group_1940" data-name="Group 1940" transform="translate(154.931 83.66)">
                <path id="Path_3746" data-name="Path 3746"
                  d="M744.8,185.687c-4.345,0-7.867-4.2-7.867-4.2s3.522-4.2,7.867-4.2,7.867,4.2,7.867,4.2S749.149,185.687,744.8,185.687Z"
                  transform="translate(-736.937 -177.288)" fill="#68999d" />
              </g>
              <g id="Group_1941" data-name="Group 1941" transform="translate(123.949 60.811)">
                <path id="Path_3747" data-name="Path 3747"
                  d="M718.663,166.408c-4.345,0-7.867-4.2-7.867-4.2s3.522-4.2,7.867-4.2,7.867,4.2,7.867,4.2S723.008,166.408,718.663,166.408Z"
                  transform="translate(-710.796 -158.009)" fill="#68999d" />
              </g>
              <g id="Group_1942" data-name="Group 1942" transform="translate(110.579 12.662)">
                <path id="Path_3748" data-name="Path 3748"
                  d="M707.839,126.272c-1.723,3.989-6.976,5.557-6.976,5.557s-2.458-4.9-.736-8.888,6.975-5.557,6.975-5.557S709.561,122.282,707.839,126.272Z"
                  transform="translate(-699.514 -117.384)" fill="#68999d" />
              </g>
              <g id="Group_1943" data-name="Group 1943" transform="translate(148.158 69.096)">
                <path id="Path_3749" data-name="Path 3749"
                  d="M740.132,173.325c-3.741,2.21-8.91.386-8.91.386s.9-5.408,4.638-7.618,8.91-.385,8.91-.385S743.873,171.116,740.132,173.325Z"
                  transform="translate(-731.222 -165)" fill="#68999d" />
              </g>
              <g id="Group_1944" data-name="Group 1944" transform="translate(105.05 76.362)">
                <path id="Path_3750" data-name="Path 3750"
                  d="M703.759,179.456c-3.74,2.209-8.909.385-8.909.385s.9-5.407,4.636-7.617,8.91-.386,8.91-.386S707.5,177.246,703.759,179.456Z"
                  transform="translate(-694.85 -171.13)" fill="#68999d" />
              </g>
              <g id="Group_1945" data-name="Group 1945" transform="translate(87.221 71.103)">
                <path id="Path_3751" data-name="Path 3751"
                  d="M688.165,175.542c-2.507,3.55-7.969,4-7.969,4s-1.4-5.3,1.107-8.849,7.969-4,7.969-4S690.67,171.993,688.165,175.542Z"
                  transform="translate(-679.807 -166.693)" fill="#68999d" />
              </g>
              <g id="Group_1946" data-name="Group 1946" transform="translate(122.914 26.533)">
                <path id="Path_3752" data-name="Path 3752"
                  d="M718.832,137.413c-3.74,2.209-8.91.385-8.91.385s.9-5.408,4.638-7.617,8.91-.386,8.91-.386S722.573,135.2,718.832,137.413Z"
                  transform="translate(-709.922 -129.087)" fill="#68999d" />
              </g>
              <g id="Group_1947" data-name="Group 1947" transform="translate(91.563 49.165)">
                <path id="Path_3753" data-name="Path 3753"
                  d="M692.38,156.508c-3.742,2.21-8.91.386-8.91.386s.9-5.408,4.638-7.617,8.91-.386,8.91-.386S696.121,154.3,692.38,156.508Z"
                  transform="translate(-683.47 -148.183)" fill="#68999d" />
              </g>
              <g id="Group_1948" data-name="Group 1948" transform="translate(126.729 81.071)">
                <path id="Path_3754" data-name="Path 3754"
                  d="M722.051,183.429c-3.742,2.21-8.91.385-8.91.385s.9-5.407,4.638-7.617,8.909-.385,8.909-.385S725.792,181.218,722.051,183.429Z"
                  transform="translate(-713.141 -175.104)" fill="#68999d" />
              </g>
              <g id="Group_1949" data-name="Group 1949" transform="translate(138.011 39.13)">
                <path id="Path_3755" data-name="Path 3755"
                  d="M731.018,148.565c-2.505,3.55-7.968,4-7.968,4s-1.4-5.3,1.106-8.849,7.969-4,7.969-4S733.523,145.015,731.018,148.565Z"
                  transform="translate(-722.66 -139.716)" fill="#68999d" />
              </g>
              <g id="Group_1950" data-name="Group 1950" transform="translate(105.652 58.584)">
                <path id="Path_3756" data-name="Path 3756"
                  d="M703.715,164.979c-2.506,3.55-7.968,4-7.968,4s-1.4-5.3,1.107-8.849,7.968-4,7.968-4S706.222,161.429,703.715,164.979Z"
                  transform="translate(-695.357 -156.13)" fill="#68999d" />
              </g>
              <g id="Group_1951" data-name="Group 1951" transform="translate(148.89 51.316)">
                <path id="Path_3757" data-name="Path 3757"
                  d="M740.565,158.349c-4.173,1.21-8.725-1.843-8.725-1.843s2.213-5.015,6.386-6.225,8.727,1.843,8.727,1.843S744.738,157.139,740.565,158.349Z"
                  transform="translate(-731.84 -149.998)" fill="#68999d" />
              </g>
              <g id="Group_1952" data-name="Group 1952" transform="translate(94.257 31.634)">
                <path id="Path_3758" data-name="Path 3758"
                  d="M694.468,141.742c-4.173,1.21-8.725-1.843-8.725-1.843s2.214-5.015,6.387-6.223,8.725,1.842,8.725,1.842S698.643,140.532,694.468,141.742Z"
                  transform="translate(-685.743 -133.392)" fill="#68999d" />
              </g>
              <g id="Group_1953" data-name="Group 1953" transform="translate(113.423 43.349)">
                <path id="Path_3759" data-name="Path 3759"
                  d="M710.639,151.627c-4.173,1.21-8.725-1.843-8.725-1.843s2.214-5.015,6.387-6.225,8.725,1.843,8.725,1.843S714.812,150.417,710.639,151.627Z"
                  transform="translate(-701.914 -143.276)" fill="#68999d" />
              </g>
              <g id="Group_1954" data-name="Group 1954" transform="translate(63.97 72.355)">
                <path id="Path_3760" data-name="Path 3760"
                  d="M668.913,176.1c-4.173,1.209-8.725-1.843-8.725-1.843s2.214-5.015,6.387-6.225,8.725,1.843,8.725,1.843S673.086,174.891,668.913,176.1Z"
                  transform="translate(-660.188 -167.75)" fill="#68999d" />
              </g>
              <g id="Group_1955" data-name="Group 1955" transform="translate(3.78 88.757)">
                <path id="Path_3761" data-name="Path 3761"
                  d="M617.27,181.589c4.345,0,7.867,4.2,7.867,4.2s-3.522,4.2-7.867,4.2-7.867-4.2-7.867-4.2S612.925,181.589,617.27,181.589Z"
                  transform="translate(-609.403 -181.589)" fill="#68999d" />
              </g>
              <g id="Group_1956" data-name="Group 1956" transform="translate(37.494 108.758)">
                <path id="Path_3762" data-name="Path 3762"
                  d="M645.716,198.465c4.345,0,7.867,4.2,7.867,4.2s-3.522,4.2-7.867,4.2-7.867-4.2-7.867-4.2S641.371,198.465,645.716,198.465Z"
                  transform="translate(-637.849 -198.465)" fill="#68999d" />
              </g>
              <g id="Group_1957" data-name="Group 1957" transform="translate(57.663 150.861)">
                <path id="Path_3763" data-name="Path 3763"
                  d="M655.48,239.546c1.722-3.989,6.975-5.557,6.975-5.557s2.458,4.9.736,8.888-6.975,5.557-6.975,5.557S653.756,243.536,655.48,239.546Z"
                  transform="translate(-654.867 -233.989)" fill="#68999d" />
              </g>
              <g id="Group_1958" data-name="Group 1958" transform="translate(24.567 88.702)">
                <path id="Path_3764" data-name="Path 3764"
                  d="M631.58,182.636c3.742-2.21,8.91-.386,8.91-.386s-.9,5.408-4.638,7.617-8.91.386-8.91.386S627.839,184.845,631.58,182.636Z"
                  transform="translate(-626.942 -181.542)" fill="#68999d" />
              </g>
              <g id="Group_1959" data-name="Group 1959" transform="translate(62.131 88.702)">
                <path id="Path_3765" data-name="Path 3765"
                  d="M663.275,182.636c3.74-2.21,8.909-.386,8.909-.386s-.9,5.408-4.638,7.617-8.909.386-8.909.386S659.533,184.845,663.275,182.636Z"
                  transform="translate(-658.637 -181.542)" fill="#68999d" />
              </g>
              <g id="Group_1960" data-name="Group 1960" transform="translate(76.947 157.439)">
                <path id="Path_3766" data-name="Path 3766"
                  d="M672.634,243.544c2.507-3.55,7.969-4,7.969-4s1.4,5.3-1.107,8.85-7.969,4-7.969,4S670.128,247.092,672.634,243.544Z"
                  transform="translate(-671.138 -239.539)" fill="#68999d" />
              </g>
              <g id="Group_1961" data-name="Group 1961" transform="translate(40.716 142.017)">
                <path id="Path_3767" data-name="Path 3767"
                  d="M645.206,227.62c3.742-2.209,8.91-.385,8.91-.385s-.9,5.408-4.638,7.617-8.91.386-8.91.386S641.465,229.83,645.206,227.62Z"
                  transform="translate(-640.568 -226.527)" fill="#68999d" />
              </g>
              <g id="Group_1962" data-name="Group 1962" transform="translate(72.067 119.385)">
                <path id="Path_3768" data-name="Path 3768"
                  d="M671.658,208.525c3.742-2.21,8.91-.386,8.91-.386s-.9,5.408-4.638,7.617-8.91.386-8.91.386S667.917,210.734,671.658,208.525Z"
                  transform="translate(-667.02 -207.431)" fill="#68999d" />
              </g>
              <g id="Group_1963" data-name="Group 1963" transform="translate(39.254 94.07)">
                <path id="Path_3769" data-name="Path 3769"
                  d="M643.97,187.165c3.742-2.209,8.91-.385,8.91-.385s-.9,5.408-4.638,7.617-8.909.386-8.909.386S640.23,189.375,643.97,187.165Z"
                  transform="translate(-639.334 -186.072)" fill="#68999d" />
              </g>
              <g id="Group_1964" data-name="Group 1964" transform="translate(29.314 125.984)">
                <path id="Path_3770" data-name="Path 3770"
                  d="M632.443,217c2.505-3.55,7.968-4.006,7.968-4.006s1.4,5.3-1.106,8.85-7.968,4-7.968,4S629.937,220.555,632.443,217Z"
                  transform="translate(-630.947 -212.999)" fill="#68999d" />
              </g>
              <g id="Group_1965" data-name="Group 1965" transform="translate(61.672 106.53)">
                <path id="Path_3771" data-name="Path 3771"
                  d="M659.746,200.591c2.505-3.55,7.968-4.006,7.968-4.006s1.4,5.3-1.107,8.85-7.968,4-7.968,4S657.239,204.141,659.746,200.591Z"
                  transform="translate(-658.249 -196.585)" fill="#68999d" />
              </g>
              <g id="Group_1966" data-name="Group 1966" transform="translate(14.69 112.84)">
                <path id="Path_3772" data-name="Path 3772"
                  d="M624.995,202.192c4.173-1.209,8.725,1.843,8.725,1.843s-2.214,5.015-6.387,6.225-8.725-1.843-8.725-1.843S620.822,203.4,624.995,202.192Z"
                  transform="translate(-618.608 -201.909)" fill="#68999d" />
              </g>
              <g id="Group_1967" data-name="Group 1967" transform="translate(67.808 137.7)">
                <path id="Path_3773" data-name="Path 3773"
                  d="M669.814,223.168c4.173-1.21,8.725,1.843,8.725,1.843s-2.214,5.015-6.387,6.223-8.725-1.842-8.725-1.842S665.641,224.378,669.814,223.168Z"
                  transform="translate(-663.427 -222.885)" fill="#68999d" />
              </g>
              <g id="Group_1968" data-name="Group 1968" transform="translate(48.643 125.985)">
                <path id="Path_3774" data-name="Path 3774"
                  d="M653.643,213.283c4.173-1.21,8.725,1.843,8.725,1.843s-2.213,5.014-6.386,6.225-8.727-1.843-8.727-1.843S649.47,214.493,653.643,213.283Z"
                  transform="translate(-647.256 -213)" fill="#68999d" />
              </g>
              <g id="Group_1969" data-name="Group 1969" transform="translate(68.611 172.728)">
                <path id="Path_3775" data-name="Path 3775" d="M707.317,300.686H664.1l1.673-48.247h39.866Z"
                  transform="translate(-664.104 -252.439)" fill="#b8d6d6" />
              </g>
            </g>
          </g>
          <g id="h2-2" data-name="Group 2033" transform="translate(783.476 165.722)">
            <g id="Group_2032" data-name="Group 2032" transform="translate(0)">
              <g id="Group_1972" data-name="Group 1972">
                <circle id="Ellipse_1460" data-name="Ellipse 1460" cx="72.525" cy="72.525" r="72.525" fill="#b8d6d6" />
              </g>
              <g id="Group_1973" data-name="Group 1973" transform="translate(74.188 5.546)">
                <path id="Path_3776" data-name="Path 3776"
                  d="M830.561,150.977c0,3.573-3.454,6.469-3.454,6.469s-3.454-2.9-3.454-6.469,3.454-6.47,3.454-6.47S830.561,147.4,830.561,150.977Z"
                  transform="translate(-823.654 -144.507)" fill="#68999d" />
              </g>
              <g id="Group_1974" data-name="Group 1974" transform="translate(49.171 28.408)">
                <path id="Path_3777" data-name="Path 3777"
                  d="M809.453,170.267c0,3.572-3.454,6.469-3.454,6.469s-3.454-2.9-3.454-6.469S806,163.8,806,163.8,809.453,166.694,809.453,170.267Z"
                  transform="translate(-802.546 -163.797)" fill="#68999d" />
              </g>
              <g id="Group_1975" data-name="Group 1975" transform="translate(9.577 44.994)">
                <path id="Path_3778" data-name="Path 3778"
                  d="M776.448,178.295c3.279,1.416,4.57,5.736,4.57,5.736s-4.028,2.022-7.309.6-4.57-5.735-4.57-5.735S773.168,176.878,776.448,178.295Z"
                  transform="translate(-769.139 -177.791)" fill="#68999d" />
              </g>
              <g id="Group_1976" data-name="Group 1976" transform="translate(59.582 11.358)">
                <path id="Path_3779" data-name="Path 3779"
                  d="M818.177,153.225c1.817,3.077.317,7.327.317,7.327s-4.447-.737-6.264-3.814-.318-7.327-.318-7.327S816.359,150.148,818.177,153.225Z"
                  transform="translate(-811.331 -149.411)" fill="#68999d" />
              </g>
              <g id="Group_1977" data-name="Group 1977" transform="translate(61.959 45.748)">
                <path id="Path_3780" data-name="Path 3780"
                  d="M820.182,182.241c1.818,3.077.318,7.327.318,7.327s-4.447-.737-6.264-3.813-.318-7.327-.318-7.327S818.365,179.165,820.182,182.241Z"
                  transform="translate(-813.336 -178.428)" fill="#68999d" />
              </g>
              <g id="Group_1978" data-name="Group 1978" transform="translate(8.772 60.692)">
                <path id="Path_3781" data-name="Path 3781"
                  d="M775.737,192.267c2.919,2.061,3.292,6.553,3.292,6.553s-4.358,1.15-7.277-.911-3.292-6.552-3.292-6.552S772.818,190.206,775.737,192.267Z"
                  transform="translate(-768.46 -191.037)" fill="#68999d" />
              </g>
              <g id="Group_1979" data-name="Group 1979" transform="translate(20.984 31.058)">
                <path id="Path_3782" data-name="Path 3782"
                  d="M785.609,169.847c1.818,3.076.318,7.327.318,7.327s-4.447-.737-6.264-3.814-.318-7.327-.318-7.327S783.792,166.77,785.609,169.847Z"
                  transform="translate(-778.763 -166.033)" fill="#68999d" />
              </g>
              <g id="Group_1980" data-name="Group 1980" transform="translate(39.594 56.838)">
                <path id="Path_3783" data-name="Path 3783"
                  d="M801.312,191.6c1.818,3.077.318,7.327.318,7.327s-4.447-.737-6.264-3.814-.318-7.327-.318-7.327S799.495,188.522,801.312,191.6Z"
                  transform="translate(-794.466 -187.785)" fill="#68999d" />
              </g>
              <g id="Group_1981" data-name="Group 1981" transform="translate(65.832 27.922)">
                <path id="Path_3784" data-name="Path 3784"
                  d="M823.45,167.2c1.817,3.077.316,7.327.316,7.327s-4.447-.737-6.264-3.814-.317-7.326-.317-7.326S821.631,164.124,823.45,167.2Z"
                  transform="translate(-816.604 -163.387)" fill="#68999d" />
              </g>
              <g id="Group_1982" data-name="Group 1982" transform="translate(31.342 21.682)">
                <path id="Path_3785" data-name="Path 3785"
                  d="M794.78,159.351c2.919,2.061,3.294,6.553,3.294,6.553s-4.358,1.151-7.277-.91-3.293-6.552-3.293-6.552S791.861,157.291,794.78,159.351Z"
                  transform="translate(-787.503 -158.122)" fill="#68999d" />
              </g>
              <g id="Group_1983" data-name="Group 1983" transform="translate(47.34 48.29)">
                <path id="Path_3786" data-name="Path 3786"
                  d="M808.278,181.8c2.919,2.06,3.294,6.552,3.294,6.552s-4.359,1.151-7.277-.909S801,180.893,801,180.893,805.359,179.742,808.278,181.8Z"
                  transform="translate(-801.001 -180.573)" fill="#68999d" />
              </g>
              <g id="Group_1984" data-name="Group 1984" transform="translate(45.621 9.656)">
                <path id="Path_3787" data-name="Path 3787"
                  d="M806.418,153.227c.994,3.432-1.516,7.175-1.516,7.175s-4.123-1.82-5.118-5.252,1.515-7.175,1.515-7.175S805.422,149.8,806.418,153.227Z"
                  transform="translate(-799.551 -147.975)" fill="#68999d" />
              </g>
              <g id="Group_1985" data-name="Group 1985" transform="translate(25.178 53.336)">
                <path id="Path_3788" data-name="Path 3788"
                  d="M789.17,190.083c.994,3.431-1.516,7.175-1.516,7.175s-4.123-1.82-5.119-5.253,1.516-7.175,1.516-7.175S788.174,186.65,789.17,190.083Z"
                  transform="translate(-782.302 -184.83)" fill="#68999d" />
              </g>
              <g id="Group_1986" data-name="Group 1986" transform="translate(34.812 37.577)">
                <path id="Path_3789" data-name="Path 3789"
                  d="M797.3,176.785c1,3.431-1.516,7.175-1.516,7.175s-4.123-1.82-5.118-5.252,1.515-7.175,1.515-7.175S796.3,173.353,797.3,176.785Z"
                  transform="translate(-790.431 -171.533)" fill="#68999d" />
              </g>
              <g id="Group_1987" data-name="Group 1987" transform="translate(65.617 74.759)">
                <path id="Path_3790" data-name="Path 3790"
                  d="M816.423,209.375c0-3.572,3.454-6.469,3.454-6.469s3.454,2.9,3.454,6.469-3.454,6.47-3.454,6.47S816.423,212.948,816.423,209.375Z"
                  transform="translate(-816.423 -202.906)" fill="#68999d" />
              </g>
              <g id="Group_1988" data-name="Group 1988" transform="translate(87.814 103.988)">
                <path id="Path_3791" data-name="Path 3791"
                  d="M835.151,234.037c0-3.572,3.454-6.469,3.454-6.469s3.453,2.9,3.453,6.469-3.453,6.47-3.453,6.47S835.151,237.61,835.151,234.037Z"
                  transform="translate(-835.151 -227.568)" fill="#68999d" />
              </g>
              <g id="Group_1989" data-name="Group 1989" transform="translate(122.435 92.993)">
                <path id="Path_3792" data-name="Path 3792"
                  d="M868.933,225.136c-3.279-1.418-4.57-5.736-4.57-5.736s4.028-2.022,7.309-.6,4.57,5.735,4.57,5.735S872.214,226.552,868.933,225.136Z"
                  transform="translate(-864.363 -218.291)" fill="#68999d" />
              </g>
              <g id="Group_1990" data-name="Group 1990" transform="translate(77.223 122.253)">
                <path id="Path_3793" data-name="Path 3793"
                  d="M827.113,250.3c-1.817-3.076-.316-7.326-.316-7.326s4.446.737,6.264,3.813.316,7.327.316,7.327S828.93,253.381,827.113,250.3Z"
                  transform="translate(-826.215 -242.979)" fill="#68999d" />
              </g>
              <g id="Group_1991" data-name="Group 1991" transform="translate(74.188 88.447)">
                <path id="Path_3794" data-name="Path 3794"
                  d="M824.554,221.781c-1.818-3.076-.318-7.326-.318-7.326s4.447.737,6.264,3.813.318,7.327.318,7.327S826.37,224.857,824.554,221.781Z"
                  transform="translate(-823.654 -214.455)" fill="#68999d" />
              </g>
              <g id="Group_1992" data-name="Group 1992" transform="translate(125.973 79.572)">
                <path id="Path_3795" data-name="Path 3795"
                  d="M870.64,213.839c-2.919-2.061-3.293-6.553-3.293-6.553s4.358-1.15,7.277.911,3.292,6.552,3.292,6.552S873.56,215.9,870.64,213.839Z"
                  transform="translate(-867.348 -206.966)" fill="#68999d" />
              </g>
              <g id="Group_1993" data-name="Group 1993" transform="translate(115.163 103.136)">
                <path id="Path_3796" data-name="Path 3796"
                  d="M859.127,234.176c-1.818-3.077-.318-7.327-.318-7.327s4.447.737,6.264,3.814.318,7.327.318,7.327S860.943,237.253,859.127,234.176Z"
                  transform="translate(-858.227 -226.849)" fill="#68999d" />
              </g>
              <g id="Group_1994" data-name="Group 1994" transform="translate(96.552 77.356)">
                <path id="Path_3797" data-name="Path 3797"
                  d="M843.423,212.424c-1.818-3.077-.318-7.327-.318-7.327s4.447.737,6.264,3.814.318,7.326.318,7.326S845.24,215.5,843.423,212.424Z"
                  transform="translate(-842.524 -205.097)" fill="#68999d" />
              </g>
              <g id="Group_1995" data-name="Group 1995" transform="translate(70.315 106.273)">
                <path id="Path_3798" data-name="Path 3798"
                  d="M821.285,236.823c-1.817-3.077-.317-7.327-.317-7.327s4.447.737,6.264,3.814.316,7.326.316,7.326S823.1,239.9,821.285,236.823Z"
                  transform="translate(-820.387 -229.496)" fill="#68999d" />
              </g>
              <g id="Group_1996" data-name="Group 1996" transform="translate(101.979 115.551)">
                <path id="Path_3799" data-name="Path 3799"
                  d="M850.4,244.2c-2.919-2.061-3.294-6.553-3.294-6.553s4.358-1.151,7.277.91,3.294,6.552,3.294,6.552S853.316,246.257,850.4,244.2Z"
                  transform="translate(-847.103 -237.324)" fill="#68999d" />
              </g>
              <g id="Group_1997" data-name="Group 1997" transform="translate(79.253 74.011)">
                <path id="Path_3800" data-name="Path 3800"
                  d="M831.222,209.147c-2.919-2.06-3.294-6.552-3.294-6.552s4.358-1.152,7.277.909,3.294,6.553,3.294,6.553S834.141,211.208,831.222,209.147Z"
                  transform="translate(-827.928 -202.274)" fill="#68999d" />
              </g>
              <g id="Group_1998" data-name="Group 1998" transform="translate(85.983 88.942)">
                <path id="Path_3801" data-name="Path 3801"
                  d="M836.9,221.745c-2.919-2.06-3.292-6.552-3.292-6.552s4.358-1.152,7.276.909,3.294,6.553,3.294,6.553S839.818,223.806,836.9,221.745Z"
                  transform="translate(-833.606 -214.872)" fill="#68999d" />
              </g>
              <g id="Group_1999" data-name="Group 1999" transform="translate(91.171 123.252)">
                <path id="Path_3802" data-name="Path 3802"
                  d="M838.216,251c-.994-3.432,1.516-7.175,1.516-7.175s4.123,1.819,5.118,5.252-1.515,7.175-1.515,7.175S839.212,254.428,838.216,251Z"
                  transform="translate(-837.983 -243.822)" fill="#68999d" />
              </g>
              <g id="Group_2000" data-name="Group 2000" transform="translate(111.613 79.571)">
                <path id="Path_3803" data-name="Path 3803"
                  d="M855.464,214.141c-.994-3.431,1.516-7.175,1.516-7.175s4.123,1.82,5.119,5.252-1.516,7.176-1.516,7.176S856.46,217.573,855.464,214.141Z"
                  transform="translate(-855.231 -206.966)" fill="#68999d" />
              </g>
              <g id="Group_2001" data-name="Group 2001" transform="translate(101.979 95.332)">
                <path id="Path_3804" data-name="Path 3804"
                  d="M847.336,227.439c-1-3.432,1.516-7.175,1.516-7.175s4.123,1.82,5.118,5.252-1.515,7.175-1.515,7.175S848.331,230.87,847.336,227.439Z"
                  transform="translate(-847.103 -220.264)" fill="#68999d" />
              </g>
              <g id="Group_2002" data-name="Group 2002" transform="translate(127.404 68.796)">
                <path id="Path_3805" data-name="Path 3805"
                  d="M875.025,204.781c-3.573,0-6.47-3.454-6.47-3.454s2.9-3.454,6.47-3.454,6.469,3.454,6.469,3.454S878.6,204.781,875.025,204.781Z"
                  transform="translate(-868.555 -197.874)" fill="#68999d" />
              </g>
              <g id="Group_2003" data-name="Group 2003" transform="translate(101.927 50.006)">
                <path id="Path_3806" data-name="Path 3806"
                  d="M853.528,188.927c-3.572,0-6.469-3.454-6.469-3.454s2.9-3.454,6.469-3.454,6.47,3.454,6.47,3.454S857.1,188.927,853.528,188.927Z"
                  transform="translate(-847.059 -182.02)" fill="#68999d" />
              </g>
              <g id="Group_2004" data-name="Group 2004" transform="translate(90.931 10.412)">
                <path id="Path_3807" data-name="Path 3807"
                  d="M844.627,155.922c-1.417,3.281-5.736,4.57-5.736,4.57s-2.022-4.028-.606-7.309,5.736-4.57,5.736-4.57S846.043,152.641,844.627,155.922Z"
                  transform="translate(-837.781 -148.613)" fill="#68999d" />
              </g>
              <g id="Group_2005" data-name="Group 2005" transform="translate(121.834 56.819)">
                <path id="Path_3808" data-name="Path 3808"
                  d="M871.182,194.615c-3.076,1.818-7.326.318-7.326.318s.736-4.447,3.813-6.264,7.327-.318,7.327-.318S874.258,192.8,871.182,194.615Z"
                  transform="translate(-863.856 -187.769)" fill="#68999d" />
              </g>
              <g id="Group_2006" data-name="Group 2006" transform="translate(86.384 62.794)">
                <path id="Path_3809" data-name="Path 3809"
                  d="M841.272,199.656c-3.076,1.818-7.327.318-7.327.318s.737-4.447,3.814-6.264,7.327-.318,7.327-.318S844.349,197.839,841.272,199.656Z"
                  transform="translate(-833.945 -192.81)" fill="#68999d" />
              </g>
              <g id="Group_2007" data-name="Group 2007" transform="translate(71.724 58.469)">
                <path id="Path_3810" data-name="Path 3810"
                  d="M828.448,196.438c-2.061,2.919-6.553,3.292-6.553,3.292s-1.15-4.358.911-7.277,6.552-3.292,6.552-3.292S830.509,193.519,828.448,196.438Z"
                  transform="translate(-821.575 -189.161)" fill="#68999d" />
              </g>
              <g id="Group_2008" data-name="Group 2008" transform="translate(101.075 21.818)">
                <path id="Path_3811" data-name="Path 3811"
                  d="M853.667,165.083c-3.077,1.818-7.327.318-7.327.318s.737-4.447,3.814-6.264,7.326-.318,7.326-.318S856.743,163.266,853.667,165.083Z"
                  transform="translate(-846.34 -158.237)" fill="#68999d" />
              </g>
              <g id="Group_2009" data-name="Group 2009" transform="translate(75.295 40.429)">
                <path id="Path_3812" data-name="Path 3812"
                  d="M831.915,180.786c-3.077,1.818-7.327.318-7.327.318s.737-4.447,3.814-6.264,7.325-.318,7.325-.318S834.99,178.969,831.915,180.786Z"
                  transform="translate(-824.588 -173.94)" fill="#68999d" />
              </g>
              <g id="Group_2010" data-name="Group 2010" transform="translate(104.212 66.667)">
                <path id="Path_3813" data-name="Path 3813"
                  d="M856.314,202.924c-3.077,1.817-7.327.316-7.327.316s.737-4.446,3.813-6.264,7.327-.316,7.327-.316S859.389,201.107,856.314,202.924Z"
                  transform="translate(-848.987 -196.078)" fill="#68999d" />
              </g>
              <g id="Group_2011" data-name="Group 2011" transform="translate(113.489 32.177)">
                <path id="Path_3814" data-name="Path 3814"
                  d="M863.688,174.254c-2.061,2.919-6.553,3.294-6.553,3.294s-1.151-4.358.91-7.277,6.552-3.294,6.552-3.294S865.748,171.335,863.688,174.254Z"
                  transform="translate(-856.815 -166.977)" fill="#68999d" />
              </g>
              <g id="Group_2012" data-name="Group 2012" transform="translate(86.879 48.175)">
                <path id="Path_3815" data-name="Path 3815"
                  d="M841.236,187.752c-2.061,2.919-6.553,3.294-6.553,3.294s-1.151-4.358.91-7.277,6.553-3.294,6.553-3.294S843.3,184.833,841.236,187.752Z"
                  transform="translate(-834.363 -180.475)" fill="#68999d" />
              </g>
              <g id="Group_2013" data-name="Group 2013" transform="translate(122.435 42.198)">
                <path id="Path_3816" data-name="Path 3816"
                  d="M871.538,182.3c-3.431.994-7.175-1.516-7.175-1.516s1.82-4.123,5.253-5.119,7.175,1.516,7.175,1.516S874.97,181.3,871.538,182.3Z"
                  transform="translate(-864.363 -175.432)" fill="#68999d" />
              </g>
              <g id="Group_2014" data-name="Group 2014" transform="translate(77.51 26.013)">
                <path id="Path_3817" data-name="Path 3817"
                  d="M833.632,168.644c-3.431.994-7.175-1.516-7.175-1.516s1.82-4.123,5.252-5.119,7.175,1.516,7.175,1.516S837.064,167.649,833.632,168.644Z"
                  transform="translate(-826.457 -161.776)" fill="#68999d" />
              </g>
              <g id="Group_2015" data-name="Group 2015" transform="translate(93.27 35.647)">
                <path id="Path_3818" data-name="Path 3818"
                  d="M846.93,176.772c-3.432,1-7.175-1.515-7.175-1.515s1.819-4.124,5.251-5.119,7.175,1.515,7.175,1.515S850.361,175.778,846.93,176.772Z"
                  transform="translate(-839.755 -169.905)" fill="#68999d" />
              </g>
              <g id="Group_2016" data-name="Group 2016" transform="translate(52.604 59.499)">
                <path id="Path_3819" data-name="Path 3819"
                  d="M812.618,196.9c-3.432,1-7.175-1.515-7.175-1.515s1.819-4.124,5.252-5.119,7.175,1.515,7.175,1.515S816.049,195.9,812.618,196.9Z"
                  transform="translate(-805.443 -190.03)" fill="#68999d" />
              </g>
              <g id="Group_2017" data-name="Group 2017" transform="translate(3.109 72.988)">
                <path id="Path_3820" data-name="Path 3820"
                  d="M770.15,201.411c3.573,0,6.47,3.454,6.47,3.454s-2.9,3.454-6.47,3.454-6.469-3.454-6.469-3.454S766.578,201.411,770.15,201.411Z"
                  transform="translate(-763.681 -201.411)" fill="#68999d" />
              </g>
              <g id="Group_2018" data-name="Group 2018" transform="translate(30.832 89.434)">
                <path id="Path_3821" data-name="Path 3821"
                  d="M793.542,215.288c3.573,0,6.47,3.454,6.47,3.454s-2.9,3.454-6.47,3.454-6.469-3.454-6.469-3.454S789.968,215.288,793.542,215.288Z"
                  transform="translate(-787.073 -215.288)" fill="#68999d" />
              </g>
              <g id="Group_2019" data-name="Group 2019" transform="translate(47.418 124.056)">
                <path id="Path_3822" data-name="Path 3822"
                  d="M801.571,249.07c1.416-3.279,5.735-4.57,5.735-4.57s2.022,4.028.606,7.309-5.735,4.57-5.735,4.57S800.153,252.351,801.571,249.07Z"
                  transform="translate(-801.067 -244.5)" fill="#68999d" />
              </g>
              <g id="Group_2020" data-name="Group 2020" transform="translate(20.202 72.941)">
                <path id="Path_3823" data-name="Path 3823"
                  d="M781.917,202.272c3.077-1.818,7.327-.318,7.327-.318s-.737,4.447-3.813,6.264-7.327.318-7.327.318S778.841,204.088,781.917,202.272Z"
                  transform="translate(-778.104 -201.372)" fill="#68999d" />
              </g>
              <g id="Group_2021" data-name="Group 2021" transform="translate(51.092 72.941)">
                <path id="Path_3824" data-name="Path 3824"
                  d="M807.98,202.272c3.077-1.818,7.327-.318,7.327-.318s-.737,4.447-3.813,6.264-7.327.318-7.327.318S804.9,204.088,807.98,202.272Z"
                  transform="translate(-804.167 -201.372)" fill="#68999d" />
              </g>
              <g id="Group_2022" data-name="Group 2022" transform="translate(63.275 129.465)">
                <path id="Path_3825" data-name="Path 3825"
                  d="M815.677,252.356c2.061-2.918,6.553-3.292,6.553-3.292s1.151,4.358-.91,7.277-6.553,3.292-6.553,3.292S813.616,255.276,815.677,252.356Z"
                  transform="translate(-814.447 -249.064)" fill="#68999d" />
              </g>
              <g id="Group_2023" data-name="Group 2023" transform="translate(33.482 116.784)">
                <path id="Path_3826" data-name="Path 3826"
                  d="M793.122,239.264c3.077-1.818,7.327-.318,7.327-.318s-.737,4.447-3.813,6.264-7.327.318-7.327.318S790.046,241.08,793.122,239.264Z"
                  transform="translate(-789.309 -238.364)" fill="#68999d" />
              </g>
              <g id="Group_2024" data-name="Group 2024" transform="translate(59.263 98.173)">
                <path id="Path_3827" data-name="Path 3827"
                  d="M814.875,223.561c3.076-1.818,7.326-.318,7.326-.318s-.737,4.447-3.813,6.264-7.327.318-7.327.318S811.8,225.377,814.875,223.561Z"
                  transform="translate(-811.061 -222.661)" fill="#68999d" />
              </g>
              <g id="Group_2025" data-name="Group 2025" transform="translate(32.278 77.356)">
                <path id="Path_3828" data-name="Path 3828"
                  d="M792.107,206c3.077-1.818,7.327-.318,7.327-.318s-.737,4.447-3.814,6.264-7.327.318-7.327.318S789.03,207.813,792.107,206Z"
                  transform="translate(-788.293 -205.097)" fill="#68999d" />
              </g>
              <g id="Group_2026" data-name="Group 2026" transform="translate(24.105 103.6)">
                <path id="Path_3829" data-name="Path 3829"
                  d="M782.627,230.534c2.06-2.919,6.552-3.294,6.552-3.294s1.151,4.358-.909,7.277-6.553,3.294-6.553,3.294S780.566,233.453,782.627,230.534Z"
                  transform="translate(-781.397 -227.24)" fill="#68999d" />
              </g>
              <g id="Group_2027" data-name="Group 2027" transform="translate(50.714 87.603)">
                <path id="Path_3830" data-name="Path 3830"
                  d="M805.078,217.035c2.061-2.919,6.553-3.292,6.553-3.292s1.151,4.358-.91,7.276-6.552,3.294-6.552,3.294S803.018,219.955,805.078,217.035Z"
                  transform="translate(-803.849 -213.743)" fill="#68999d" />
              </g>
              <g id="Group_2028" data-name="Group 2028" transform="translate(12.08 92.791)">
                <path id="Path_3831" data-name="Path 3831"
                  d="M776.5,218.353c3.431-.994,7.175,1.516,7.175,1.516s-1.82,4.123-5.252,5.118-7.175-1.515-7.175-1.515S773.07,219.349,776.5,218.353Z"
                  transform="translate(-771.251 -218.12)" fill="#68999d" />
              </g>
              <g id="Group_2029" data-name="Group 2029" transform="translate(55.76 113.233)">
                <path id="Path_3832" data-name="Path 3832"
                  d="M813.357,235.6c3.432-.994,7.175,1.516,7.175,1.516s-1.82,4.123-5.252,5.119-7.175-1.516-7.175-1.516S809.926,236.6,813.357,235.6Z"
                  transform="translate(-808.106 -235.368)" fill="#68999d" />
              </g>
              <g id="Group_2030" data-name="Group 2030" transform="translate(40 103.6)">
                <path id="Path_3833" data-name="Path 3833"
                  d="M800.061,227.473c3.431-1,7.175,1.516,7.175,1.516s-1.821,4.123-5.252,5.118-7.176-1.515-7.176-1.515S796.628,228.468,800.061,227.473Z"
                  transform="translate(-794.808 -227.24)" fill="#68999d" />
              </g>
              <g id="Group_2031" data-name="Group 2031" transform="translate(56.42 142.038)">
                <path id="Path_3834" data-name="Path 3834" d="M844.2,299.347H808.663l1.376-39.675h32.783Z"
                  transform="translate(-808.663 -259.672)" fill="#b8d6d6" />
              </g>
            </g>
          </g>
          <g id="h2-1" data-name="Group 2093" transform="translate(9.138 154.52)">
            <g id="h2-5" data-name="Group 2092">
              <circle id="Ellipse_1461" data-name="Ellipse 1461" cx="76.996" cy="76.996" r="76.996" fill="#b8d6d6" />
              <g id="Group_2034" data-name="Group 2034" transform="translate(78.761 5.887)">
                <path id="Path_3835" data-name="Path 3835"
                  d="M181.5,142.213c0,3.793-3.667,6.868-3.667,6.868s-3.666-3.076-3.666-6.868,3.666-6.869,3.666-6.869S181.5,138.42,181.5,142.213Z"
                  transform="translate(-174.165 -135.344)" fill="#68999d" />
              </g>
              <g id="Group_2035" data-name="Group 2035" transform="translate(52.202 30.159)">
                <path id="Path_3836" data-name="Path 3836"
                  d="M159.089,162.691c0,3.794-3.667,6.868-3.667,6.868s-3.666-3.074-3.666-6.868,3.666-6.868,3.666-6.868S159.089,158.9,159.089,162.691Z"
                  transform="translate(-151.756 -155.823)" fill="#68999d" />
              </g>
              <g id="Group_2036" data-name="Group 2036" transform="translate(10.168 47.767)">
                <path id="Path_3837" data-name="Path 3837"
                  d="M124.048,171.215c3.482,1.5,4.852,6.089,4.852,6.089s-4.277,2.146-7.759.642-4.852-6.088-4.852-6.088S120.566,169.711,124.048,171.215Z"
                  transform="translate(-116.289 -170.68)" fill="#68999d" />
              </g>
              <g id="Group_2037" data-name="Group 2037" transform="translate(63.255 12.059)">
                <path id="Path_3838" data-name="Path 3838"
                  d="M168.35,144.6c1.929,3.265.337,7.778.337,7.778s-4.721-.783-6.65-4.049-.337-7.778-.337-7.778S166.42,141.333,168.35,144.6Z"
                  transform="translate(-161.082 -140.551)" fill="#68999d" />
              </g>
              <g id="Group_2038" data-name="Group 2038" transform="translate(65.778 48.568)">
                <path id="Path_3839" data-name="Path 3839"
                  d="M170.479,175.4c1.929,3.266.337,7.778.337,7.778s-4.721-.782-6.65-4.049-.337-7.778-.337-7.778S168.549,172.138,170.479,175.4Z"
                  transform="translate(-163.211 -171.356)" fill="#68999d" />
              </g>
              <g id="Group_2039" data-name="Group 2039" transform="translate(9.314 64.433)">
                <path id="Path_3840" data-name="Path 3840"
                  d="M123.294,186.048c3.1,2.188,3.5,6.957,3.5,6.957s-4.627,1.221-7.725-.967-3.5-6.956-3.5-6.956S120.195,183.86,123.294,186.048Z"
                  transform="translate(-115.569 -184.742)" fill="#68999d" />
              </g>
              <g id="Group_2040" data-name="Group 2040" transform="translate(22.277 32.973)">
                <path id="Path_3841" data-name="Path 3841"
                  d="M133.775,162.246c1.929,3.266.337,7.778.337,7.778s-4.721-.782-6.65-4.049-.337-7.778-.337-7.778S131.845,158.98,133.775,162.246Z"
                  transform="translate(-126.507 -158.197)" fill="#68999d" />
              </g>
              <g id="Group_2041" data-name="Group 2041" transform="translate(42.036 60.342)">
                <path id="Path_3842" data-name="Path 3842"
                  d="M150.446,185.339c1.93,3.266.337,7.778.337,7.778s-4.721-.782-6.65-4.049-.337-7.778-.337-7.778S148.516,182.073,150.446,185.339Z"
                  transform="translate(-143.178 -181.29)" fill="#68999d" />
              </g>
              <g id="Group_2042" data-name="Group 2042" transform="translate(69.89 29.642)">
                <path id="Path_3843" data-name="Path 3843"
                  d="M173.948,159.436c1.93,3.266.337,7.778.337,7.778s-4.721-.782-6.65-4.049-.337-7.778-.337-7.778S172.018,156.17,173.948,159.436Z"
                  transform="translate(-166.68 -155.387)" fill="#68999d" />
              </g>
              <g id="Group_2043" data-name="Group 2043" transform="translate(33.274 23.018)">
                <path id="Path_3844" data-name="Path 3844"
                  d="M143.511,151.1c3.1,2.188,3.5,6.957,3.5,6.957s-4.627,1.222-7.726-.966-3.5-6.956-3.5-6.956S140.412,148.916,143.511,151.1Z"
                  transform="translate(-135.785 -149.798)" fill="#68999d" />
              </g>
              <g id="Group_2044" data-name="Group 2044" transform="translate(50.258 51.267)">
                <path id="Path_3845" data-name="Path 3845"
                  d="M157.84,174.939c3.1,2.188,3.5,6.957,3.5,6.957s-4.626,1.221-7.725-.966-3.5-6.957-3.5-6.957S154.742,172.751,157.84,174.939Z"
                  transform="translate(-150.115 -173.633)" fill="#68999d" />
              </g>
              <g id="Group_2045" data-name="Group 2045" transform="translate(48.433 10.251)">
                <path id="Path_3846" data-name="Path 3846"
                  d="M155.866,144.6c1.056,3.643-1.609,7.617-1.609,7.617s-4.377-1.932-5.434-5.575,1.609-7.617,1.609-7.617S154.81,140.958,155.866,144.6Z"
                  transform="translate(-148.575 -139.026)" fill="#68999d" />
              </g>
              <g id="Group_2046" data-name="Group 2046" transform="translate(26.731 56.624)">
                <path id="Path_3847" data-name="Path 3847"
                  d="M137.554,183.729c1.057,3.642-1.608,7.617-1.608,7.617s-4.378-1.933-5.434-5.575,1.608-7.618,1.608-7.618S136.5,180.086,137.554,183.729Z"
                  transform="translate(-130.264 -178.153)" fill="#68999d" />
              </g>
              <g id="Group_2047" data-name="Group 2047" transform="translate(36.958 39.893)">
                <path id="Path_3848" data-name="Path 3848"
                  d="M146.184,169.611c1.056,3.643-1.609,7.618-1.609,7.618s-4.377-1.933-5.434-5.576,1.609-7.617,1.609-7.617S145.128,165.968,146.184,169.611Z"
                  transform="translate(-138.893 -164.036)" fill="#68999d" />
              </g>
              <g id="Group_2048" data-name="Group 2048" transform="translate(69.663 79.368)">
                <path id="Path_3849" data-name="Path 3849"
                  d="M166.488,204.211c0-3.793,3.667-6.868,3.667-6.868s3.667,3.076,3.667,6.868-3.667,6.868-3.667,6.868S166.488,208,166.488,204.211Z"
                  transform="translate(-166.488 -197.343)" fill="#68999d" />
              </g>
              <g id="Group_2049" data-name="Group 2049" transform="translate(93.226 110.398)">
                <path id="Path_3850" data-name="Path 3850"
                  d="M186.37,230.393c0-3.793,3.667-6.868,3.667-6.868s3.666,3.076,3.666,6.868-3.666,6.868-3.666,6.868S186.37,234.187,186.37,230.393Z"
                  transform="translate(-186.37 -223.525)" fill="#68999d" />
              </g>
              <g id="Group_2050" data-name="Group 2050" transform="translate(129.983 98.725)">
                <path id="Path_3851" data-name="Path 3851"
                  d="M222.235,220.942c-3.482-1.5-4.852-6.088-4.852-6.088s4.277-2.148,7.759-.644,4.852,6.089,4.852,6.089S225.717,222.446,222.235,220.942Z"
                  transform="translate(-217.383 -213.676)" fill="#68999d" />
              </g>
              <g id="Group_2051" data-name="Group 2051" transform="translate(81.982 129.789)">
                <path id="Path_3852" data-name="Path 3852"
                  d="M177.837,247.664c-1.93-3.266-.337-7.778-.337-7.778s4.721.782,6.65,4.049.337,7.778.337,7.778S179.767,250.93,177.837,247.664Z"
                  transform="translate(-176.883 -239.886)" fill="#68999d" />
              </g>
              <g id="Group_2052" data-name="Group 2052" transform="translate(78.761 93.899)">
                <path id="Path_3853" data-name="Path 3853"
                  d="M175.119,217.382c-1.929-3.266-.337-7.778-.337-7.778s4.721.782,6.65,4.047.337,7.778.337,7.778S177.049,220.648,175.119,217.382Z"
                  transform="translate(-174.165 -209.604)" fill="#68999d" />
              </g>
              <g id="Group_2053" data-name="Group 2053" transform="translate(133.738 84.477)">
                <path id="Path_3854" data-name="Path 3854"
                  d="M224.047,208.95c-3.1-2.188-3.5-6.957-3.5-6.957s4.627-1.221,7.725.967,3.5,6.957,3.5,6.957S227.146,211.138,224.047,208.95Z"
                  transform="translate(-220.552 -201.654)" fill="#68999d" />
              </g>
              <g id="Group_2054" data-name="Group 2054" transform="translate(122.262 109.494)">
                <path id="Path_3855" data-name="Path 3855"
                  d="M211.823,230.54c-1.929-3.265-.337-7.778-.337-7.778s4.721.783,6.65,4.049.337,7.778.337,7.778S213.753,233.807,211.823,230.54Z"
                  transform="translate(-210.869 -222.762)" fill="#68999d" />
              </g>
              <g id="Group_2055" data-name="Group 2055" transform="translate(102.504 82.125)">
                <path id="Path_3856" data-name="Path 3856"
                  d="M195.152,207.447c-1.93-3.265-.337-7.778-.337-7.778s4.721.783,6.65,4.049.337,7.778.337,7.778S197.082,210.714,195.152,207.447Z"
                  transform="translate(-194.198 -199.669)" fill="#68999d" />
              </g>
              <g id="Group_2056" data-name="Group 2056" transform="translate(74.65 112.824)">
                <path id="Path_3857" data-name="Path 3857"
                  d="M171.65,233.35c-1.929-3.265-.337-7.778-.337-7.778s4.721.782,6.65,4.049.337,7.778.337,7.778S173.58,236.617,171.65,233.35Z"
                  transform="translate(-170.696 -225.572)" fill="#68999d" />
              </g>
              <g id="Group_2057" data-name="Group 2057" transform="translate(108.265 122.674)">
                <path id="Path_3858" data-name="Path 3858"
                  d="M202.555,241.179c-3.1-2.188-3.5-6.956-3.5-6.956s4.627-1.222,7.726.965,3.5,6.957,3.5,6.957S205.655,243.367,202.555,241.179Z"
                  transform="translate(-199.059 -233.883)" fill="#68999d" />
              </g>
              <g id="Group_2058" data-name="Group 2058" transform="translate(84.14 78.572)">
                <path id="Path_3859" data-name="Path 3859"
                  d="M182.2,203.969c-3.1-2.188-3.5-6.957-3.5-6.957s4.626-1.222,7.725.966,3.5,6.957,3.5,6.957S185.3,206.157,182.2,203.969Z"
                  transform="translate(-178.703 -196.672)" fill="#68999d" />
              </g>
              <g id="Group_2059" data-name="Group 2059" transform="translate(91.283 94.424)">
                <path id="Path_3860" data-name="Path 3860"
                  d="M188.226,217.343c-3.1-2.187-3.5-6.956-3.5-6.956s4.626-1.222,7.725.966,3.5,6.956,3.5,6.956S191.324,219.531,188.226,217.343Z"
                  transform="translate(-184.73 -210.047)" fill="#68999d" />
              </g>
              <g id="Group_2060" data-name="Group 2060" transform="translate(96.791 130.85)">
                <path id="Path_3861" data-name="Path 3861"
                  d="M189.625,248.4c-1.056-3.643,1.609-7.617,1.609-7.617s4.377,1.932,5.434,5.575-1.609,7.618-1.609,7.618S190.681,252.041,189.625,248.4Z"
                  transform="translate(-189.377 -240.781)" fill="#68999d" />
              </g>
              <g id="Group_2061" data-name="Group 2061" transform="translate(118.493 84.477)">
                <path id="Path_3862" data-name="Path 3862"
                  d="M207.937,209.271c-1.057-3.643,1.608-7.617,1.608-7.617s4.378,1.932,5.434,5.575-1.608,7.617-1.608,7.617S208.993,212.914,207.937,209.271Z"
                  transform="translate(-207.689 -201.654)" fill="#68999d" />
              </g>
              <g id="Group_2062" data-name="Group 2062" transform="translate(108.266 101.208)">
                <path id="Path_3863" data-name="Path 3863"
                  d="M199.307,223.388c-1.056-3.643,1.609-7.617,1.609-7.617s4.377,1.932,5.434,5.575-1.609,7.617-1.609,7.617S200.363,227.031,199.307,223.388Z"
                  transform="translate(-199.059 -215.771)" fill="#68999d" />
              </g>
              <g id="Group_2063" data-name="Group 2063" transform="translate(135.258 73.037)">
                <path id="Path_3864" data-name="Path 3864"
                  d="M228.7,199.334c-3.794,0-6.868-3.667-6.868-3.667S224.908,192,228.7,192s6.868,3.666,6.868,3.666S232.495,199.334,228.7,199.334Z"
                  transform="translate(-221.834 -192.001)" fill="#68999d" />
              </g>
              <g id="Group_2064" data-name="Group 2064" transform="translate(108.21 53.089)">
                <path id="Path_3865" data-name="Path 3865"
                  d="M205.88,182.5c-3.793,0-6.868-3.667-6.868-3.667s3.076-3.666,6.868-3.666,6.868,3.666,6.868,3.666S209.674,182.5,205.88,182.5Z"
                  transform="translate(-199.012 -175.17)" fill="#68999d" />
              </g>
              <g id="Group_2065" data-name="Group 2065" transform="translate(96.537 11.055)">
                <path id="Path_3866" data-name="Path 3866"
                  d="M196.429,147.462c-1.5,3.483-6.09,4.852-6.09,4.852s-2.146-4.277-.642-7.759,6.089-4.851,6.089-4.851S197.933,143.98,196.429,147.462Z"
                  transform="translate(-189.163 -139.704)" fill="#68999d" />
              </g>
              <g id="Group_2066" data-name="Group 2066" transform="translate(129.344 60.322)">
                <path id="Path_3867" data-name="Path 3867"
                  d="M224.622,188.541c-3.265,1.93-7.778.337-7.778.337s.783-4.721,4.049-6.65,7.778-.337,7.778-.337S227.889,186.611,224.622,188.541Z"
                  transform="translate(-216.844 -181.273)" fill="#68999d" />
              </g>
              <g id="Group_2067" data-name="Group 2067" transform="translate(91.711 66.665)">
                <path id="Path_3868" data-name="Path 3868"
                  d="M192.868,193.893c-3.265,1.929-7.777.337-7.777.337s.782-4.721,4.047-6.65,7.778-.337,7.778-.337S196.135,191.963,192.868,193.893Z"
                  transform="translate(-185.091 -186.625)" fill="#68999d" />
              </g>
              <g id="Group_2068" data-name="Group 2068" transform="translate(76.145 62.074)">
                <path id="Path_3869" data-name="Path 3869"
                  d="M179.254,190.476c-2.188,3.1-6.957,3.5-6.957,3.5s-1.221-4.627.967-7.725,6.957-3.5,6.957-3.5S181.442,187.378,179.254,190.476Z"
                  transform="translate(-171.958 -182.751)" fill="#68999d" />
              </g>
              <g id="Group_2069" data-name="Group 2069" transform="translate(107.305 23.164)">
                <path id="Path_3870" data-name="Path 3870"
                  d="M206.027,157.189c-3.265,1.929-7.778.337-7.778.337s.782-4.721,4.049-6.65,7.778-.337,7.778-.337S209.294,155.259,206.027,157.189Z"
                  transform="translate(-198.249 -149.921)" fill="#68999d" />
              </g>
              <g id="Group_2070" data-name="Group 2070" transform="translate(79.936 42.922)">
                <path id="Path_3871" data-name="Path 3871"
                  d="M182.934,173.86c-3.265,1.929-7.778.337-7.778.337s.782-4.721,4.049-6.65,7.778-.337,7.778-.337S186.2,171.93,182.934,173.86Z"
                  transform="translate(-175.156 -166.592)" fill="#68999d" />
              </g>
              <g id="Group_2071" data-name="Group 2071" transform="translate(110.636 70.776)">
                <path id="Path_3872" data-name="Path 3872"
                  d="M208.837,197.362c-3.266,1.929-7.778.337-7.778.337s.782-4.721,4.049-6.65,7.778-.337,7.778-.337S212.1,195.432,208.837,197.362Z"
                  transform="translate(-201.059 -190.094)" fill="#68999d" />
              </g>
              <g id="Group_2072" data-name="Group 2072" transform="translate(120.486 34.161)">
                <path id="Path_3873" data-name="Path 3873"
                  d="M216.666,166.925c-2.188,3.1-6.956,3.5-6.956,3.5s-1.222-4.627.965-7.725,6.957-3.5,6.957-3.5S218.854,163.826,216.666,166.925Z"
                  transform="translate(-209.37 -159.2)" fill="#68999d" />
              </g>
              <g id="Group_2073" data-name="Group 2073" transform="translate(92.236 51.144)">
                <path id="Path_3874" data-name="Path 3874"
                  d="M192.83,181.255c-2.188,3.1-6.956,3.5-6.956,3.5s-1.222-4.627.966-7.726,6.956-3.5,6.956-3.5S195.018,178.156,192.83,181.255Z"
                  transform="translate(-185.534 -173.529)" fill="#68999d" />
              </g>
              <g id="Group_2074" data-name="Group 2074" transform="translate(129.983 44.8)">
                <path id="Path_3875" data-name="Path 3875"
                  d="M225,175.466c-3.643,1.057-7.618-1.608-7.618-1.608s1.933-4.378,5.576-5.434,7.617,1.608,7.617,1.608S228.645,174.41,225,175.466Z"
                  transform="translate(-217.383 -168.176)" fill="#68999d" />
              </g>
              <g id="Group_2075" data-name="Group 2075" transform="translate(82.288 27.617)">
                <path id="Path_3876" data-name="Path 3876"
                  d="M184.758,160.969c-3.643,1.056-7.617-1.609-7.617-1.609s1.932-4.378,5.575-5.434,7.617,1.609,7.617,1.609S188.4,159.912,184.758,160.969Z"
                  transform="translate(-177.141 -153.678)" fill="#68999d" />
              </g>
              <g id="Group_2076" data-name="Group 2076" transform="translate(99.02 37.845)">
                <path id="Path_3877" data-name="Path 3877"
                  d="M198.875,169.6c-3.643,1.056-7.617-1.608-7.617-1.608s1.932-4.378,5.575-5.434,7.617,1.608,7.617,1.608S202.518,168.542,198.875,169.6Z"
                  transform="translate(-191.258 -162.308)" fill="#68999d" />
              </g>
              <g id="Group_2077" data-name="Group 2077" transform="translate(55.847 63.167)">
                <path id="Path_3878" data-name="Path 3878"
                  d="M162.448,190.964c-3.643,1.056-7.617-1.609-7.617-1.609s1.932-4.378,5.575-5.434,7.617,1.609,7.617,1.609S166.091,189.907,162.448,190.964Z"
                  transform="translate(-154.831 -183.673)" fill="#68999d" />
              </g>
              <g id="Group_2078" data-name="Group 2078" transform="translate(3.299 77.487)">
                <path id="Path_3879" data-name="Path 3879"
                  d="M117.362,195.756c3.794,0,6.868,3.666,6.868,3.666s-3.074,3.667-6.868,3.667-6.868-3.667-6.868-3.667S113.57,195.756,117.362,195.756Z"
                  transform="translate(-110.494 -195.756)" fill="#68999d" />
              </g>
              <g id="Group_2079" data-name="Group 2079" transform="translate(32.732 94.947)">
                <path id="Path_3880" data-name="Path 3880"
                  d="M142.2,210.488c3.794,0,6.868,3.667,6.868,3.667s-3.074,3.666-6.868,3.666-6.868-3.666-6.868-3.666S138.4,210.488,142.2,210.488Z"
                  transform="translate(-135.328 -210.488)" fill="#68999d" />
              </g>
              <g id="Group_2080" data-name="Group 2080" transform="translate(50.34 131.703)">
                <path id="Path_3881" data-name="Path 3881"
                  d="M150.72,246.353c1.5-3.482,6.089-4.852,6.089-4.852s2.146,4.277.642,7.759-6.09,4.852-6.09,4.852S149.216,249.835,150.72,246.353Z"
                  transform="translate(-150.185 -241.501)" fill="#68999d" />
              </g>
              <g id="Group_2081" data-name="Group 2081" transform="translate(21.448 77.438)">
                <path id="Path_3882" data-name="Path 3882"
                  d="M129.854,196.669c3.266-1.929,7.778-.337,7.778-.337s-.782,4.721-4.047,6.65-7.778.337-7.778.337S126.589,198.6,129.854,196.669Z"
                  transform="translate(-125.807 -195.715)" fill="#68999d" />
              </g>
              <g id="Group_2082" data-name="Group 2082" transform="translate(54.241 77.438)">
                <path id="Path_3883" data-name="Path 3883"
                  d="M157.525,196.669c3.266-1.929,7.778-.337,7.778-.337s-.782,4.721-4.049,6.65-7.778.337-7.778.337S154.258,198.6,157.525,196.669Z"
                  transform="translate(-153.476 -195.715)" fill="#68999d" />
              </g>
              <g id="Group_2083" data-name="Group 2083" transform="translate(67.176 137.447)">
                <path id="Path_3884" data-name="Path 3884"
                  d="M165.7,249.842c2.188-3.1,6.957-3.5,6.957-3.5s1.221,4.627-.967,7.725-6.957,3.5-6.957,3.5S163.508,252.941,165.7,249.842Z"
                  transform="translate(-164.39 -246.347)" fill="#68999d" />
              </g>
              <g id="Group_2084" data-name="Group 2084" transform="translate(35.546 123.983)">
                <path id="Path_3885" data-name="Path 3885"
                  d="M141.751,235.941c3.266-1.929,7.778-.337,7.778-.337s-.782,4.721-4.049,6.65-7.778.337-7.778.337S138.485,237.871,141.751,235.941Z"
                  transform="translate(-137.702 -234.987)" fill="#68999d" />
              </g>
              <g id="Group_2085" data-name="Group 2085" transform="translate(62.915 104.224)">
                <path id="Path_3886" data-name="Path 3886"
                  d="M164.844,219.27c3.266-1.929,7.778-.337,7.778-.337s-.782,4.721-4.049,6.65-7.778.337-7.778.337S161.578,221.2,164.844,219.27Z"
                  transform="translate(-160.795 -218.316)" fill="#68999d" />
              </g>
              <g id="Group_2086" data-name="Group 2086" transform="translate(34.268 82.125)">
                <path id="Path_3887" data-name="Path 3887"
                  d="M140.673,200.624c3.266-1.929,7.778-.338,7.778-.338s-.782,4.722-4.049,6.651-7.778.337-7.778.337S137.407,202.552,140.673,200.624Z"
                  transform="translate(-136.624 -199.669)" fill="#68999d" />
              </g>
              <g id="Group_2087" data-name="Group 2087" transform="translate(25.591 109.986)">
                <path id="Path_3888" data-name="Path 3888"
                  d="M130.608,226.673c2.188-3.1,6.957-3.5,6.957-3.5s1.222,4.627-.966,7.726-6.956,3.5-6.956,3.5S128.421,229.773,130.608,226.673Z"
                  transform="translate(-129.303 -223.177)" fill="#68999d" />
              </g>
              <g id="Group_2088" data-name="Group 2088" transform="translate(53.84 93.003)">
                <path id="Path_3889" data-name="Path 3889"
                  d="M154.444,212.344c2.188-3.1,6.956-3.5,6.956-3.5s1.222,4.626-.965,7.725-6.957,3.5-6.957,3.5S152.256,215.442,154.444,212.344Z"
                  transform="translate(-153.138 -208.848)" fill="#68999d" />
              </g>
              <g id="Group_2089" data-name="Group 2089" transform="translate(12.825 98.511)">
                <path id="Path_3890" data-name="Path 3890"
                  d="M124.106,213.743c3.643-1.056,7.617,1.609,7.617,1.609s-1.932,4.377-5.575,5.434-7.617-1.609-7.617-1.609S120.463,214.8,124.106,213.743Z"
                  transform="translate(-118.531 -213.495)" fill="#68999d" />
              </g>
              <g id="Group_2090" data-name="Group 2090" transform="translate(59.197 120.214)">
                <path id="Path_3891" data-name="Path 3891"
                  d="M163.233,232.055c3.643-1.056,7.618,1.608,7.618,1.608s-1.933,4.378-5.576,5.434-7.617-1.608-7.617-1.608S159.591,233.111,163.233,232.055Z"
                  transform="translate(-157.658 -231.807)" fill="#68999d" />
              </g>
              <g id="Group_2091" data-name="Group 2091" transform="translate(42.466 109.986)">
                <path id="Path_3892" data-name="Path 3892"
                  d="M149.116,223.425c3.643-1.056,7.618,1.609,7.618,1.609s-1.933,4.377-5.576,5.434-7.617-1.609-7.617-1.609S145.473,224.481,149.116,223.425Z"
                  transform="translate(-143.541 -223.177)" fill="#68999d" />
              </g>
              <path id="Path_3893" data-name="Path 3893" d="M195.974,299.729H158.249l1.461-42.121h34.8Z"
                transform="translate(-98.351 -106.815)" fill="#b8d6d6" />
            </g>
          </g>
          <g id="h2-4" data-name="Group 2106" transform="translate(217.991 88.184)">
            <rect id="Rectangle_828" data-name="Rectangle 828" width="109.142" height="62.777"
              transform="translate(285.957 90.713)" fill="#f9f5ec" />
            <path id="Path_3894" data-name="Path 3894" d="M469.964,152.915h182.61l-36.555-43.584H469.964Z"
              transform="translate(-249.479 -67.937)" fill="#fff" />
            <rect id="Rectangle_829" data-name="Rectangle 829" width="182.61" height="1.491"
              transform="translate(220.485 84.978)" fill="#ded1be" />
            <path id="Path_3895" data-name="Path 3895"
              d="M648.21,151.607a2.869,2.869,0,0,1,2.868-2.868h0v-1.376H469.964v4.244Z"
              transform="translate(-249.479 -60.894)" fill="#dfd2bf" />
            <path id="Path_3896" data-name="Path 3896" d="M424.367,152.915H283.93l36.555-43.584H424.367Z"
              transform="translate(-283.93 -67.937)" fill="#fff" />
            <rect id="Rectangle_830" data-name="Rectangle 830" width="140.437" height="1.491"
              transform="translate(140.437 86.469) rotate(-180)" fill="#ded1be" />
            <path id="Path_3897" data-name="Path 3897"
              d="M288.06,151.607a2.868,2.868,0,0,0-2.867-2.868h0v-1.376h138.94v4.244Z"
              transform="translate(-283.696 -60.894)" fill="#dfd2bf" />
            <path id="Path_3898" data-name="Path 3898"
              d="M568.377,226.713V154.226l-94.93-73.443-48.287,38.232v44.922H291.876V333.189H695.6V226.713Z"
              transform="translate(-282.459 -73.224)" fill="#f8f4eb" />
            <g id="Group_2094" data-name="Group 2094" transform="translate(134.951)">
              <path id="Path_3899" data-name="Path 3899" d="M404.3,119.014,452.59,80.783l94.968,73.443"
                transform="translate(-396.59 -73.224)" fill="none" stroke="#8080b7" stroke-miterlimit="10"
                stroke-width="1" />
              <path id="Path_3900" data-name="Path 3900"
                d="M453.8,74.405l-56.009,44.351v6.085h11.4v-7.4L453.8,82.175l91.29,70.479v7.4h11.382v-6.087Z"
                transform="translate(-397.795 -74.405)" fill="#f9f5ec" />
              <path id="Path_3901" data-name="Path 3901"
                d="M404.335,124.474v13.257h6.092v-6.194l42.194-33.359,88.875,68.57v6.194h6.093V159.685L452.622,86.242Z"
                transform="translate(-396.584 -72.213)" fill="#dfd2bf" opacity="0.5" />
              <path id="Path_3902" data-name="Path 3902"
                d="M404.3,119.014v8.9h6.092v-7l42.194-33.359,88.876,68.57v7h6.093v-8.9L452.59,80.783Z"
                transform="translate(-396.59 -73.224)" fill="#ded1be" />
            </g>
            <path id="Path_3903" data-name="Path 3903" d="M457.312,327.687H360.738V148.724l48.287-38.232,48.287,38.232Z"
              transform="translate(-269.706 -67.722)" fill="#fff" />
            <g id="Group_2095" data-name="Group 2095" transform="translate(83.319 35.211)">
              <path id="Path_3904" data-name="Path 3904" d="M360.738,148.724l48.287-38.232,48.287,38.232"
                transform="translate(-353.025 -102.934)" fill="none" stroke="#8080b7" stroke-miterlimit="10"
                stroke-width="1" />
              <path id="Path_3905" data-name="Path 3905"
                d="M410.24,104.115l-56.01,44.351v6.085h11.4v-7.4l44.609-35.267,44.609,35.267v7.4H466.23v-6.087Z"
                transform="translate(-354.23 -104.115)" fill="#f9f5ec" />
              <path id="Path_3906" data-name="Path 3906"
                d="M360.771,154.184v13.257h6.092v-6.194l42.194-33.359,42.194,33.359v6.194h6.093V154.184l-48.287-38.232Z"
                transform="translate(-353.019 -101.923)" fill="#dfd2bf" opacity="0.5" />
              <path id="Path_3907" data-name="Path 3907"
                d="M360.738,148.724v8.9h6.092v-7l42.194-33.359,42.194,33.359v7h6.093v-8.9l-48.287-38.232Z"
                transform="translate(-353.025 -102.934)" fill="#ded1be" />
            </g>
            <g id="Group_2096" data-name="Group 2096" transform="translate(96.26 160.142)">
              <rect id="Rectangle_831" data-name="Rectangle 831" width="68.454" height="6.958"
                transform="translate(8.832 2.753)" fill="#f9f5ec" />
              <rect id="Rectangle_832" data-name="Rectangle 832" width="53.907" height="4.97"
                transform="translate(16.105 82.504)" fill="#dfd2bf" />
              <rect id="Rectangle_833" data-name="Rectangle 833" width="73.042" height="5.429"
                transform="translate(6.538 87.474)" fill="#ded1be" />
              <rect id="Rectangle_834" data-name="Rectangle 834" width="86.117" height="6.92"
                transform="translate(0 92.903)" fill="#f9f5ec" />
              <rect id="Rectangle_835" data-name="Rectangle 835" width="7.168" height="77.763"
                transform="translate(10.418 9.711)" fill="#f9f5ec" />
              <rect id="Rectangle_836" data-name="Rectangle 836" width="7.168" height="77.763"
                transform="translate(68.53 9.711)" fill="#f9f5ec" />
              <rect id="Rectangle_837" data-name="Rectangle 837" width="50.944" height="72.793"
                transform="translate(17.587 9.711)" fill="#ded1be" />
              <path id="Path_3908" data-name="Path 3908" d="M405.346,219.235H398.98l-1.185-9.711h8.736Z"
                transform="translate(-359.104 -209.524)" fill="#ded1be" />
              <rect id="Rectangle_838" data-name="Rectangle 838" width="7.368" height="67.441"
                transform="translate(20.129 12.387)" fill="#fff" />
              <rect id="Rectangle_839" data-name="Rectangle 839" width="7.368" height="67.441"
                transform="translate(58.38 12.387)" fill="#fff" />
              <rect id="Rectangle_840" data-name="Rectangle 840" width="25.52" height="70.117"
                transform="translate(30.299 12.387)" fill="#f9f5ec" />
              <rect id="Rectangle_841" data-name="Rectangle 841" width="19.135" height="60.789"
                transform="translate(33.491 15.427)" fill="#ded1be" />
              <rect id="Rectangle_842" data-name="Rectangle 842" width="16.306" height="33.434"
                transform="translate(34.906 17.09)" fill="#f9f5ec" />
              <rect id="Rectangle_843" data-name="Rectangle 843" width="16.306" height="23.28"
                transform="translate(34.906 51.559)" fill="#f9f5ec" />
              <path id="Path_3909" data-name="Path 3909"
                d="M441.055,223.376H432.3V235H381.356V223.376H372.6v-5.658h68.454Z"
                transform="translate(-363.77 -208.007)" fill="#dfd2bf" opacity="0.5" />
            </g>
            <g id="Group_2097" data-name="Group 2097" transform="translate(112.366 81.002)">
              <rect id="Rectangle_844" data-name="Rectangle 844" width="53.907" height="6.958"
                transform="translate(0 2.753)" fill="#f9f5ec" />
              <rect id="Rectangle_845" data-name="Rectangle 845" width="53.907" height="4.97"
                transform="translate(0 56.124)" fill="#dfd2bf" />
              <rect id="Rectangle_846" data-name="Rectangle 846" width="50.944" height="46.413"
                transform="translate(1.481 9.711)" fill="#ded1be" />
              <path id="Path_3910" data-name="Path 3910" d="M405.346,152.461H398.98l-1.185-9.711h8.736Z"
                transform="translate(-375.209 -142.75)" fill="#ded1be" />
              <rect id="Rectangle_847" data-name="Rectangle 847" width="45.591" height="41.061"
                transform="translate(4.158 12.387)" fill="#fff" />
              <rect id="Rectangle_848" data-name="Rectangle 848" width="2.237" height="41.978"
                transform="translate(25.835 11.928)" fill="#ded1be" />
              <rect id="Rectangle_849" data-name="Rectangle 849" width="53.907" height="6.958"
                transform="translate(0 9.711)" fill="#dfd2bf" opacity="0.5" />
            </g>
            <g id="Group_2098" data-name="Group 2098" transform="translate(25.369 168.316)">
              <rect id="Rectangle_850" data-name="Rectangle 850" width="53.907" height="6.958"
                transform="translate(0 2.753)" fill="#f9f5ec" />
              <rect id="Rectangle_851" data-name="Rectangle 851" width="53.907" height="4.97"
                transform="translate(0 56.124)" fill="#dfd2bf" />
              <rect id="Rectangle_852" data-name="Rectangle 852" width="50.944" height="46.413"
                transform="translate(1.481 9.711)" fill="#ded1be" />
              <path id="Path_3911" data-name="Path 3911" d="M331.943,226.132h-6.366l-1.185-9.711h8.736Z"
                transform="translate(-301.806 -216.422)" fill="#ded1be" />
              <rect id="Rectangle_853" data-name="Rectangle 853" width="45.591" height="41.061"
                transform="translate(4.158 12.387)" fill="#fff" />
              <rect id="Rectangle_854" data-name="Rectangle 854" width="1.08" height="41.978"
                transform="translate(38.528 11.928)" fill="#ded1be" />
              <rect id="Rectangle_855" data-name="Rectangle 855" width="2.237" height="41.978"
                transform="translate(25.835 11.928)" fill="#ded1be" />
              <rect id="Rectangle_856" data-name="Rectangle 856" width="1.08" height="41.978"
                transform="translate(14.299 11.928)" fill="#ded1be" />
              <rect id="Rectangle_857" data-name="Rectangle 857" width="1.08" height="46.241"
                transform="translate(3.833 43.895) rotate(-90)" fill="#ded1be" />
              <rect id="Rectangle_858" data-name="Rectangle 858" width="1.08" height="46.241"
                transform="translate(3.833 33.458) rotate(-90)" fill="#ded1be" />
              <rect id="Rectangle_859" data-name="Rectangle 859" width="1.08" height="46.241"
                transform="translate(3.833 23.02) rotate(-90)" fill="#ded1be" />
              <rect id="Rectangle_860" data-name="Rectangle 860" width="53.907" height="6.958"
                transform="translate(0 9.711)" fill="#dfd2bf" opacity="0.5" />
            </g>
            <g id="Group_2099" data-name="Group 2099" transform="translate(226.937 180.635)">
              <rect id="Rectangle_861" data-name="Rectangle 861" width="84.664" height="6.958"
                transform="translate(0 2.753)" fill="#f9f5ec" />
              <rect id="Rectangle_862" data-name="Rectangle 862" width="80.011" height="69.619"
                transform="translate(2.327 9.711)" fill="#ded1be" />
              <path id="Path_3912" data-name="Path 3912" d="M514.991,236.527h-6.366l-1.185-9.711h8.736Z"
                transform="translate(-469.476 -226.816)" fill="#ded1be" />
              <rect id="Rectangle_863" data-name="Rectangle 863" width="84.664" height="6.958"
                transform="translate(0 9.711)" fill="#dfd2bf" opacity="0.5" />
            </g>
            <g id="Group_2100" data-name="Group 2100" transform="translate(320.757 180.635)">
              <rect id="Rectangle_864" data-name="Rectangle 864" width="84.664" height="6.958"
                transform="translate(0 2.753)" fill="#f9f5ec" />
              <rect id="Rectangle_865" data-name="Rectangle 865" width="80.011" height="69.619"
                transform="translate(2.327 9.711)" fill="#ded1be" />
              <path id="Path_3913" data-name="Path 3913" d="M594.152,236.527h-6.366l-1.185-9.711h8.736Z"
                transform="translate(-548.637 -226.816)" fill="#ded1be" />
              <rect id="Rectangle_866" data-name="Rectangle 866" width="84.664" height="6.958"
                transform="translate(0 9.711)" fill="#dfd2bf" opacity="0.5" />
            </g>
            <g id="Group_2101" data-name="Group 2101" transform="translate(195.893 171.262)">
              <rect id="Rectangle_867" data-name="Rectangle 867" width="15.312" height="6.958"
                transform="translate(0 2.753)" fill="#f9f5ec" />
              <rect id="Rectangle_868" data-name="Rectangle 868" width="15.312" height="4.97"
                transform="translate(0 45.491)" fill="#dfd2bf" />
              <rect id="Rectangle_869" data-name="Rectangle 869" width="14.47" height="35.78"
                transform="translate(0.421 9.711)" fill="#ded1be" />
              <path id="Path_3914" data-name="Path 3914" d="M459.539,228.618h-6.366l-1.185-9.711h8.736Z"
                transform="translate(-448.701 -218.908)" fill="#ded1be" />
              <rect id="Rectangle_870" data-name="Rectangle 870" width="10.418" height="30.428"
                transform="translate(2.447 12.387)" fill="#fff" />
              <rect id="Rectangle_871" data-name="Rectangle 871" width="15.312" height="6.958"
                transform="translate(0 9.711)" fill="#dfd2bf" opacity="0.5" />
            </g>
            <g id="Group_2102" data-name="Group 2102" transform="translate(206.186 90.713)">
              <rect id="Rectangle_872" data-name="Rectangle 872" width="53.907" height="4.97"
                transform="translate(0 46.413)" fill="#dfd2bf" />
              <rect id="Rectangle_873" data-name="Rectangle 873" width="50.944" height="46.413"
                transform="translate(1.481)" fill="#ded1be" />
              <rect id="Rectangle_874" data-name="Rectangle 874" width="45.591" height="41.061"
                transform="translate(4.158 2.676)" fill="#fff" />
              <rect id="Rectangle_875" data-name="Rectangle 875" width="2.237" height="41.978"
                transform="translate(25.835 2.217)" fill="#ded1be" />
              <rect id="Rectangle_876" data-name="Rectangle 876" width="53.907" height="6.958" fill="#dfd2bf"
                opacity="0.5" />
            </g>
            <g id="Group_2103" data-name="Group 2103" transform="translate(296.222 90.713)">
              <rect id="Rectangle_877" data-name="Rectangle 877" width="29.639" height="4.97"
                transform="translate(0 46.413)" fill="#dfd2bf" />
              <rect id="Rectangle_878" data-name="Rectangle 878" width="27.068" height="46.413"
                transform="translate(1.481)" fill="#ded1be" />
              <rect id="Rectangle_879" data-name="Rectangle 879" width="21.697" height="41.061"
                transform="translate(4.158 2.676)" fill="#fff" />
            </g>
            <g id="Group_2104" data-name="Group 2104" transform="translate(53.68 90.713)">
              <rect id="Rectangle_880" data-name="Rectangle 880" width="29.639" height="4.97"
                transform="translate(0 46.413)" fill="#dfd2bf" />
              <rect id="Rectangle_881" data-name="Rectangle 881" width="27.068" height="46.413"
                transform="translate(1.481)" fill="#ded1be" />
              <rect id="Rectangle_882" data-name="Rectangle 882" width="21.697" height="41.061"
                transform="translate(4.158 2.676)" fill="#fff" />
              <rect id="Rectangle_883" data-name="Rectangle 883" width="1.08" height="41.978"
                transform="translate(14.299 2.217)" fill="#ded1be" />
              <rect id="Rectangle_884" data-name="Rectangle 884" width="1.08" height="22.882"
                transform="translate(3.833 34.184) rotate(-90)" fill="#ded1be" />
              <rect id="Rectangle_885" data-name="Rectangle 885" width="1.08" height="22.882"
                transform="translate(3.833 23.747) rotate(-90)" fill="#ded1be" />
              <rect id="Rectangle_886" data-name="Rectangle 886" width="1.08" height="22.882"
                transform="translate(3.833 13.31) rotate(-90)" fill="#ded1be" />
            </g>
            <g id="Group_2105" data-name="Group 2105" transform="translate(351.161 90.713)">
              <rect id="Rectangle_887" data-name="Rectangle 887" width="29.639" height="4.97"
                transform="translate(0 46.413)" fill="#dfd2bf" />
              <rect id="Rectangle_888" data-name="Rectangle 888" width="27.068" height="46.413"
                transform="translate(1.481)" fill="#ded1be" />
              <rect id="Rectangle_889" data-name="Rectangle 889" width="21.697" height="41.061"
                transform="translate(4.158 2.676)" fill="#fff" />
            </g>
            <rect id="Rectangle_890" data-name="Rectangle 890" width="109.142" height="6.958"
              transform="translate(285.957 90.713)" fill="#dfd2bf" opacity="0.5" />
            <rect id="Rectangle_891" data-name="Rectangle 891" width="81.615" height="6.958"
              transform="translate(9.417 90.713)" fill="#dfd2bf" opacity="0.5" />
            <rect id="Rectangle_892" data-name="Rectangle 892" width="182.61" height="1.491"
              transform="translate(245.255 168.28)" fill="#ded1be" />
            <path id="Path_3915" data-name="Path 3915"
              d="M669.11,221.893a2.867,2.867,0,0,1,2.867-2.867h0v-1.377H490.863v4.244Z"
              transform="translate(-245.609 -47.878)" fill="#dfd2bf" opacity="0.5" />
            <path id="Path_3916" data-name="Path 3916" d="M490.863,199.492v20.029h182.61l-16.8-20.029Z"
              transform="translate(-245.609 -51.241)" fill="#fff" />
          </g>
          <path id="Path_3917" data-name="Path 3917"
            d="M173.985,115.506a12.7,12.7,0,1,1,3.41-24.92,23.216,23.216,0,0,1,42.724-10.805,17.547,17.547,0,0,1,24.766,7.305,12.646,12.646,0,0,1,15.927,11.155,9.585,9.585,0,0,1,14.515,7.066,5.512,5.512,0,1,1,1.747,10.74Z"
            transform="translate(-88.651 12.788)" fill="#fff" />
          <path id="Path_3918" data-name="Path 3918"
            d="M845.362,91.933a17.434,17.434,0,1,1,4.682-34.213A31.875,31.875,0,0,1,908.7,42.886a24.092,24.092,0,0,1,34,10.029,17.362,17.362,0,0,1,21.865,15.316,13.158,13.158,0,0,1,19.929,9.7,7.568,7.568,0,1,1,2.4,14.746Z"
            transform="translate(34.802 5.215)" fill="#fff" />
        </g>
      </svg> -->
      <ng-container *ngIf="display === 'LAPTOP' || display === 'DESKTOP'">
        <img src="assets/images/home/background_desktop.svg" alt="carrier"
          class=" absolute left-0 top-0 z-10 w-full block h-full !max-w-none" id="h1-6"/>
      </ng-container>
      <ng-container *ngIf="display === 'TABLET'">
        <img src="assets/images/home/background_tablet.svg" alt="carrier"
          class="absolute left-0 top-0 z-10 w-full block h-full !max-w-none" id="h1-6"/>
      </ng-container>
      <ng-container *ngIf="display === 'MOBILE'">
        <img src="assets/images/home/background_mobile.svg" alt="carrier"
          class="absolute left-0 top-0 z-10 w-full block h-full !max-w-none" id="h1-6"/>
      </ng-container>
    </div>
    <div class="flex flex-col laptop:block w-full">
      <div class="h-[45vh] md:h-[65vh] 3xl:h-screen w-full relative">
        <ng-container *ngIf="display === 'LAPTOP' || display === 'DESKTOP'">
          <img src="assets/images/home/PrestigeMovers_Website_Homepage__Desktop_1.svg" id="h1-8" alt="carrier"
            class=" absolute left-0 top-0 z-10 w-full block h-full !max-w-none"
            [@fadeInUp]="{ value: '', params: { delay: 1000 } }" />
          <img src="assets/images/home/PrestigeMovers_Website_Homepage__Desktop_2.svg" id="h1-12" alt="carrier"
            class="absolute left-0 top-0 z-10 w-full block h-full !max-w-none"
            [@fadeInUp]="{ value: '', params: { delay: 1400 } }" />
          <img src="assets/images/home/PrestigeMovers_Website_Homepage__Desktop_3.svg" id="h1-9" alt="carrier"
            class="absolute left-0 top-0 z-10 w-full block h-full !max-w-none"
            [@fadeInUp]="{ value: '', params: { delay: 1800 } }" />
        </ng-container>
        <ng-container *ngIf="display === 'TABLET'">
          <img src="assets/images/home/PrestigeMovers_Website_Homepage__Tablet_1.svg" id="h1-8" alt="carrier"
            class=" absolute left-0 top-0 z-10 w-full block h-full !max-w-none"
            [@fadeInUp]="{ value: '', params: { delay: 1000 } }" />
          <img src="assets/images/home/PrestigeMovers_Website_Homepage__Tablet_2.svg" id="h1-12" alt="carrier"
            class="absolute left-0 top-0 z-10 w-full block h-full !max-w-none"
            [@fadeInUp]="{ value: '', params: { delay: 1400 } }" />
          <img src="assets/images/home/Homepage__Tablet_3.svg" id="h1-9" alt="carrier"
            class="absolute left-0 top-0 z-10 w-full block h-full !max-w-none"
            [@fadeInUp]="{ value: '', params: { delay: 1800 } }" />
        </ng-container>
        <ng-container *ngIf="display === 'MOBILE'">
          <img src="assets/images/home/PrestigeMovers_Website_Homepage__Mobile_1.svg" id="h1-8" alt="carrier"
            class=" absolute left-0 top-0 z-10 w-full block h-full !max-w-none"
            [@fadeInUp]="{ value: '', params: { delay: 1000 } }" />
          <img src="assets/images/home/PrestigeMovers_Website_Homepage__Mobile_2.svg" id="h1-12" alt="carrier"
            class="absolute left-0 top-0 z-10 w-full block h-full !max-w-none"
            [@fadeInUp]="{ value: '', params: { delay: 1400 } }" />
          <img src="assets/images/home/PrestigeMovers_Website_Homepage__Mobile_3.svg" id="h1-9" alt="carrier"
            class="absolute left-0 top-0 z-10 w-full block h-full !max-w-none"
            [@fadeInUp]="{ value: '', params: { delay: 1800 } }" />
        </ng-container>
      </div>
      <div id="h1-13"
        class="text-center relative laptop:absolute laptop:right-36 laptop:top-1/3 z-10 px-8 laptop:px-0 laptop:text-end mt-5 laptop:mt-0 mb-20 md:mb-10"
        [@fadeInp]="{ value: '', params: { delay: 2200,duration:50000 } }">
        <h1
          class="text-[40px] leading-7 md:text-[64px] md:leading-10 laptop:text-[64px] laptop:leading-10 3xl:text-[64px] 3xl:leading-[64px]">
          YOUR ONE-STOP SHOP
        </h1>
        <h2 class="text-[27px] leading-[27px] md:text-[40px] md:leading-10">
          WE DELIVER EXCELLENCE EVERY <br /> STEP OF THE WAY!
        </h2>
      </div>
    </div>
  </div>
</section>

<section class="mb-16">
  <div class="container mx-auto md:px-8 laptop:px-16">
    <div class="flex items-center justify-center flex-col w-11/12 3xl:w-3/5 m-auto">
      <img src="/assets/images/logos/logo_dark_3xl.svg" alt="prestige logo" />
      <div>
        <p class="text-center mt-5 text-lg text-darkNavy mx-auto w-11/12">
          Prestige Moving & Delivery is a rapidly expanding company that delivers reliable, efficient, and swift
          services throughout Canada. Our services include moving, courier and delivery, as well as storage,
          professional packing, furniture assembly, and junk removal. Our #1 priority is to listen to your needs and
          provide top-notch solutions.
        </p>
      </div>
    </div>
  </div>
</section>
<div id="services"></div>
<section class="mb-20 mt-20">
  <div class="container mx-auto md:px-8 laptop:px-16">
    <div class="flex items-center justify-center flex-col mb-14 mt-14 px-8 laptop:px-0">
      <h3 class="text-orange text-[24px] leading-[28.8px] md:text-[32px] md:leading-[38.4px]">
        Our services
      </h3>
      <h1 class="text-[32px] leading-[32px] md:text-[64px] md:leading-[76.8px]">
        What can we do for you
      </h1>
    </div>

    <ng-container *ngIf="display === 'TABLET' || display === 'MOBILE'">
      <div>
        <swiper [config]="config" (swiper)="onSwiper($event)" (slideChange)="onSlideChange()"
          *ngIf="intersection.isElementIntersecting()">
          <ng-template *ngFor="let service of services" swiperSlide>
            <div class="flex items-center justify-center flex-col cursor-pointer"
              (click)="selectService(service?.name)">
              <img [src]="service?.url" [alt]="service?.name" class="mx-auto" />
              <h3
                class="text-center text-darkNavy mt-3 mb-6 text-[24px] leading-[28.8px] md:text-[32px] md:leading-[38.4px]">
                {{ service?.name }}
              </h3>
              <div appIntersection #intersection="intersection" (isIntersecting)="isIntersecting($event, intersection)"
                [isContinuous]="false">
                <p class="text-center mt-5 text-lg text-darkNavy mx-auto w-11/12"
                  *ngIf="intersection.isElementIntersecting()" [@enter] [@leave]>
                  {{ service?.content }}
                </p>
              </div>
            </div>
          </ng-template>
        </swiper>
      </div>
    </ng-container>
    <ng-container *ngIf="display === 'LAPTOP' || display === 'DESKTOP'">
      <div class="grid grid-cols-3 gap-[34px] justify-center">
        <div *ngFor="let service of services" class="cursor-pointer" (click)="selectService(service?.name)">
          <img [src]="service?.url" [alt]="service?.name" class="mx-auto" />
          <h3
            class="text-center text-darkNavy mt-3 mb-6 text-[24px] leading-[28.8px] md:text-[32px] md:leading-[38.4px]">
            {{ service?.name }}
          </h3>
          <div appIntersection #intersection="intersection" (isIntersecting)="isIntersecting($event, intersection)"
            [isContinuous]="false">
            <p class="text-center text-lg leading-[22.5px] text-[#363636]" *ngIf="intersection.isElementIntersecting()"
              [@enter] [@leave]>
              {{ service?.content }}
            </p>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</section>
<section class="pt-20 lg:pt-40 pb-40 bg-gradiant relative overflow-hidden">
  <div class="container mx-auto relative px-4 md:px-8 laptop:px-16">
    <div class="gap-8 grid grid-cols-1 3xl:grid-cols-2 items-center relative">
      <div class="text-center 3xl:text-left w-4/5 3xl:w-3/5 m-auto 3xl:m-0" appIntersection #intersection="intersection"
        (isIntersecting)="isIntersecting($event, intersection)" [isContinuous]="false">
        <div *ngIf="intersection.isElementIntersecting()" [@slideInLeft]="{ value: '', params: { delay: 500 } }">
          <h1
            class="text-darkNavy text-[32px] leading-[32px] md:text-[64px] md:leading-[64px] laptop:text-[64px] laptop:leading-[76.8px] 33xl:text-[64px] 33xl:leading-[64px]">
            PROFESSIONAL MOVERS YOU CAN TRUST!
          </h1>
          <p class="mt-5 mb-5 text-lg text-darkNavy w-12/12">
            Get a free estimate for you moving costs through our state-of-the-art Get a Quote platform
          </p>
        </div>
        <a routerLink="/services"
          class="rounded-lg px-9 py-4 text-basic-0 bg-orange hover:text-white relative z-10 hover:bg-orange inline-flex items-center Up cursor-pointer"
          *ngIf="intersection.isElementIntersecting()" [@fadeInUp]="{ value: '', params: { delay: 1000 } }">
          Get a Quote
        </a>
      </div>
      <div class="text-center laptop:text-left m-auto w-full" appIntersection #intersection="intersection"
        (isIntersecting)="isIntersecting($event, intersection)" [isContinuous]="false">
        <ng-container *ngIf="display === 'TABLET' || display === 'MOBILE'">
          <img *ngIf="intersection.isElementIntersecting()" [@slideInLeft]
            src="https://prestige-movers.s3.amazonaws.com/home/responsive-mover.png" alt="Movers image"
            class="m-auto w-full" style="max-width: none" />
        </ng-container>
        <ng-container *ngIf="display === 'LAPTOP' || display === 'DESKTOP'">
          <img *ngIf="intersection.isElementIntersecting()" [@slideInLeft]
            src="https://prestige-movers.s3.amazonaws.com/home/movers.png" alt="Movers image"
            class="relative right-1/4 w-full md:w-auto md:right-full laptop:right-2/4 3xl:right-[100%] "
            style="max-width: none" />
        </ng-container>
      </div>
    </div>
  </div>
</section>
<section class="customers">
  <div class="container mx-auto px-4 md:px-8 laptop:px-16">
    <div class="gap-8 grid grid-cols-1 3xl:grid-cols-2 relative w-10/12 m-auto 3xl:w-full" appIntersection
      #intersection="intersection" (isIntersecting)="isIntersecting($event, intersection)" [isContinuous]="false">
      <div class="order-2 3xl:order-1" *ngIf="intersection.isElementIntersecting()" [@slideInUp]>
        <div>
          <ul
            class="gap-8 grid grid-cols-2 md:grid-cols-3 3xl:grid-cols-2 items-center place-content-center 3xl:place-content-start">
            <li class="md:place-self-end 3xl:place-self-start">
              <img src="https://prestige-movers.s3.amazonaws.com/home/PngItem.png" alt="PngItem" />
            </li>
            <li class="md:place-self-end 3xl:place-self-start">
              <img src="https://prestige-movers.s3.amazonaws.com/home/design%20house.png" alt="design house" />
            </li>
            <li class="md:place-self-end 3xl:place-self-start">
              <img src="https://prestige-movers.s3.amazonaws.com/home/RoyalElectricSupply.png"
                alt="RoyalElectricSupply" />
            </li>
            <li class="md:place-self-end 3xl:place-self-start md:col-span-3 3xl:col-span-1">
              <img src="https://prestige-movers.s3.amazonaws.com/home/form-and-build.png" alt="form & build" />
            </li>
            <li
              class="place-self-center md:place-self-end 3xl:place-self-start col-span-2 md:col-span-3 3xl:col-span-1">
              <img src="https://prestige-movers.s3.amazonaws.com/home/surplus.png" alt="surplus" />
            </li>
          </ul>
        </div>
        <div class="mt-8 3xl:mt-0">
          <img src="https://prestige-movers.s3.amazonaws.com/home/customer.png" alt="customer" class="mx-auto" />
        </div>
      </div>
      <div class="order-1 3xl:order-2 w-full md:w-4/5 m-auto 3xl:w-full 3xl:m-0">
        <div class="text-center">
          <h3 class="text-orange text-[24px] leading-[28.8px] md:text-[32px] md:leading-[38.4px]">
            Testimonials
          </h3>
          <h1
            class="text-[32px] leading-[64px] md:text-[64px] md:leading-[64px] laptop:text-[64px] laptop:leading-[76.8px]">
            Hear from our customers
          </h1>
        </div>
        <ng-container>
          <div>
            <swiper [config]="customerConfig" (swiper)="onSwiper($event)" (slideChange)="onSlideChange()"
              *ngIf="intersection.isElementIntersecting()" [@slideInRigh]="{ value: '', params: { delay: 1000 } }">
              <ng-template *ngFor="let testimonial of testimonials" swiperSlide>
                <div class="slide-items" *ngIf="testimonial?.is_active">
                  <p class="my-7 text-center text-lg text-darkNavy w-12/12">
                    {{ testimonial?.description }}
                  </p>
                  <span class="text-xl block text-center text-darkNavy font-bold">
                    {{ testimonial?.name }}
                  </span>
                </div>
              </ng-template>
            </swiper>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</section>
<section class="bg-gray-5 py-20">
  <div class="container mx-auto px-4 md:px-8 laptop:px-16">
    <div class="gap-8 grid grid-cols-1 3xl:grid-cols-2 relative">
      <div>
        <div class="Prestige-detals" appIntersection #intersection="intersection"
          (isIntersecting)="isIntersecting($event, intersection)" [isContinuous]="false">
          <div *ngIf="intersection.isElementIntersecting()" [@slideInLeft]>
            <h3 class="text-orange text-[24px] leading-[28.8px] md:text-[32px] md:leading-[38.4px]">
              Prestige Movers by the numbers
            </h3>
            <h1
              class="text-basic-0 text-[32px] leading-[38.4px] md:text-[64px] md:leading-[76.8px] 3xl:text-[64px] 3xl:leading-[64px]">
              fast growing CANADIAN moving company at your service!
            </h1>
          </div>
          <div class="w-10/12 m-auto 3xl:w-4/5 3xl:ml-auto mt-16 wow slideInUp"
            *ngIf="intersection.isElementIntersecting()" [@slideInUp]>
            <ul class="gap-x-20 gap-y-10 grid grid-cols-1 md:grid-cols-2">
              <li class="Prestige-item" *ngFor="let percentage of info.percentages">
                <h2 class="text-basic-0 text-[48px] leading-[57.6px]">
                  {{ percentage.value }}%
                </h2>
                <div class="progress-parent">
                  <div class="progress-inner" style="--i: {{ percentage.value }}%"></div>
                </div>
                <h3 class="text-basic-0 text-[32px] leading-[38.4px]">
                  {{ percentage.name }}
                </h3>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div>
        <div class="relative parent"> <img src="https://prestige-movers.s3.amazonaws.com/home/fast_mover.png"
            alt="mover" class="relative z-10 speed" /></div>
      </div>
    </div>
    <ng-container>
      <div class="gap-8 grid grid-cols-1 laptop:grid-cols-3 mt-10">
        <div *ngFor="let item of info?.numbers">
          <div
            class="half-circle-item relative grid grid-cols-3 laptop:grid-cols-1 justify-start laptop:justify-center">
            <h2
              class="text-basic-0 text-center pt-7 md:pt-24 laptop:pt-14 basis-full md:basis-2/5 laptop:basis-auto relative z-50 text-[32px] leading-[38.4px] md:text-[48px] md:leading-[57.6px]">
              {{ item.value }}
            </h2>
            <div class="pl-2 md:pl-3 laptop:pl-0 col-span-2">
              <h3
                class="text-basic-0 laptop:text-center md:my-6 text-[24px] leading-[28.8px] md:text-[32px] md:leading-[38.4px]">
                {{ item.name }}
              </h3>
              <p class="laptop:text-center md:mt-5 text-lg text-basic-0 laptop:mx-auto w-11/12">
                {{ item.description }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</section>